// App imports.
import * as assessmentInfo from "./assessmentInfo";
import * as utility from "./utility";
import * as worker from "../baseWorker";

export enum AppPagesEnum {
  StartPage = 0,
  StartNewAssessment = 1,
  SelectStateAndYear = 2,
  Assessment1 = 3,
  Assessment2a = 4,
  Assessment2b = 5,
  Assessment3a = 6,
  Assessment3b = 7,
  Assessment4 = 8,
  OverallAssessment = 9,
}
export class BaseAssessmentObject {
  roundPercent(inPercent: number): number {
    if (inPercent === null) {
      return null;
    }
    else {
      return Math.round(inPercent * 100) / 100;
    }
  }
}


export enum Assessment1StepsEnum {
  EnterDataAverageExpenditures = 0,
  DisplaySeds = 1,
  PercentOfSeds = 2,
  NaturalGasFollowup = 3,
  FuelOilFollowup = 4,
  PropaneFollowup = 5,
  ActionPlanSummary = 6,
}
export enum Assessment1FuelStatusEnum {
  InRangeNoIssues = 0,
  UnderMin = 1,
  OverMax = 2,
  ZeroAverageExpenditure = 3,
  NoSEDSData = 4,
}
export class Assessment1FuelTypeInfo extends BaseAssessmentObject {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  computedAverageExpenditure?: number;
  sedsElectricNonHeatExpenditure?: number;
  sedsElectricNonHeatCode: string;
  viewAnyway: boolean;
  IncludingEnergyUseChargesFlag: string;
  IncludingEnergyUseChargesDesc: string;
  IncludingEnergyDeliveryChargesFlag: string;
  IncludingEnergyDeliveryChargesDesc: string;
  IncludeSupplierChargesFlag: string;
  IncludeSupplierChargesDesc: string;
  IncludingEnergyOptionalChargesFlag: string;
  IncludingEnergyOptionalChargesDesc: string;
  Including12MonthOnlyFlag: string;
  Including12MonthOnlyDesc: string;
  IncludingComplete12MonthFlag: string;
  IncludingComplete12MonthDesc: string;
  IndicatingLessThan12MonthFlag: string;
  IndicatingLessThan12MonthDesc: string;
  ReportingAfterDiscountsFlag: string;
  ReportingAfterDiscountsDesc: string;
  CheckOutliersFlag: string;
  CheckOutliersDesc: string;
  IncludeOnlyAmountBilledFlag: string;
  IncludeOnlyAmountBilledDesc: string;
  SignificantSupplierChargesFlag: string;
  SignificantSupplierChargesDesc: string;
  ZeroAvgExpenditureDataReasonDesc: string;
  OtherReasonDesc: string;
  totalAssistedhHNum: number;

  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string) {
    super();
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.computedAverageExpenditure = 0;
    this.sedsElectricNonHeatExpenditure = 0;
    this.sedsElectricNonHeatCode = '';
    this.viewAnyway = null;
    this.IncludingEnergyUseChargesFlag = null;
    this.IncludingEnergyUseChargesDesc = '';
    this.IncludingEnergyDeliveryChargesFlag = null;
    this.IncludingEnergyDeliveryChargesDesc = '';
    this.IncludingEnergyOptionalChargesDesc = '';
    this.Including12MonthOnlyFlag = null;
    this.Including12MonthOnlyDesc = '';
    this.IncludingComplete12MonthFlag = null;
    this.IncludingComplete12MonthDesc = '';
    this.IndicatingLessThan12MonthFlag = null;
    this.IndicatingLessThan12MonthDesc = '';
    this.ReportingAfterDiscountsFlag = null;
    this.ReportingAfterDiscountsDesc = '';
    this.ZeroAvgExpenditureDataReasonDesc = '';
    this.OtherReasonDesc = '';
    this.CheckOutliersFlag = null;
    this.IncludeOnlyAmountBilledFlag = null;

  }
  get averageExpenseGreaterThanSeds(): boolean {
    if (this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null
      || this.computedAverageExpenditure === null
      || this.computedAverageExpenditure == 0) {
      return null;
    }
    else if (this.computedAverageExpenditure < this.sedsElectricNonHeatExpenditure) {
      return false;
    }
    else {
      return true;
    }
  }
  get percentOfSedsStatus(): number {
    if (this.sedsElectricNonHeatExpenditure === 0 || this.sedsElectricNonHeatExpenditure === null) {
      return Assessment1FuelStatusEnum.NoSEDSData;
    }
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure == 0) {
      return Assessment1FuelStatusEnum.ZeroAverageExpenditure;
    }
    else if (this.roundPercent(this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) < 0.5) {
      return Assessment1FuelStatusEnum.UnderMin;
    }
    else if (this.roundPercent(this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) > 1.5) {
      return Assessment1FuelStatusEnum.OverMax
    }
    else {
      return Assessment1FuelStatusEnum.InRangeNoIssues
    }
  }
  get percentOfSedsString(): string {
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure === 0) {
      return 'N/A';
    }
    else if (this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return 'N/A';
    }
    let percent: number = Math.round((this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) * 100);
    return String(percent) + "%";
  }
  get percentSpendingLessString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return null;
    }
    let percent: number = Math.round((1 - (this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure)) * 100);
    return String(percent) + "%";
  }
  get percentSpendingMoreString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return null;
    }
    let percent: number = Math.round(((this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) - 1) * 100);
    return String(percent) + "%";
  }
}
export class Assessment1FuelTypesStatusHolder {
  NaturalGas: Assessment1FuelTypeInfo;
  FuelOil: Assessment1FuelTypeInfo;
  Propane: Assessment1FuelTypeInfo;
  FiscalYear: number;
  Grantee: number;

  constructor() {
    this.NaturalGas = new Assessment1FuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas");
    this.FuelOil = new Assessment1FuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil");
    this.Propane = new Assessment1FuelTypeInfo("Propane", "Propane", "Propane", "Propane");
  }
}
export class Assessment1StepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showComputedAverageExpenditure: boolean;
  showSedsElectricNonHeatExpenditure: boolean;
  showPercentOfSedsString: boolean;
  showPercentOfSedsStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showComputedAverageExpenditure: boolean,
    showSedsElectricNonHeatExpenditure: boolean,
    showPercentOfSedsString: boolean,
    showPercentOfSedsStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showComputedAverageExpenditure = showComputedAverageExpenditure;
    this.showSedsElectricNonHeatExpenditure = showSedsElectricNonHeatExpenditure;
    this.showPercentOfSedsString = showPercentOfSedsString;
    this.showPercentOfSedsStatus = showPercentOfSedsStatus;
  }
}

export enum Assessment2aStepsEnum {
  EnterNumVendors = 0,
  EnterVendorsReq = 1,
  EnterVendorsRec = 2,
  Results = 3,
  ZeroVendorForType = 4,
  ActionPlanSummary = 5,
}
export enum Assessment2aStatusEnum {
  MeetsMinRequirement5Plus = 0,
  MeetsMinRequirementUnder5 = 1,
  RequestedUnderMin5Plus = 2,
  ReceivedUnderMin5Plus = 3,
  RequestedUnderMinUnder5 = 4,
  ReceivedUnderMinUnder5 = 5,
}
export class Assessment2aModel extends BaseAssessmentObject {
  FiscalYear: number;
  Grantee: number;
  investorOwnedUtilVendorsNum?: number;
  investorOwnedUtilRequestedVendorsNum?: number;
  investorOwnedUtilReceivedVendorsNum?: number;
  publicMuniUtilVendorsNum?: number;
  publicMuniUtilRequestedVendorsNum?: number;
  publicMuniUtilReceivedVendorsNum?: number;
  ruralCoopVendorsNum?: number;
  ruralCoopRequestedVendorsNum?: number;
  ruralCoopReceivedVendorsNum?: number;
  unknownTypeVendorsNum?: number;
  unknownTypeRequestedVendorsNum?: number;
  unknownTypeReceivedVendorsNum?: number;
  requestDataMinVendorsDesc: string;
  vendorAgreementsHaveDataCollectionReqFlag: string;
  vendorAgreementsHaveDataCollectionReqDesc: string;
  clientWaiversMeetVendorRequirementsFlag: string;
  clientWaiversMeetVendorRequirementsDesc: string;
  vendorsAlertedTimelyMannerFlag: string;
  vendorsAlertedTimelyMannerDesc: string;
  deliveredFuelSmallElectricVendorFlag: string;
  deliveredFuelSmallElectricVendorDesc: string;
  smallElectricVendorCollectDataFlag: string;
  smallElectricVendorCollectDataDesc: string;
  otherReasonDesc: string;
  publicMuniplanRequestDataDesc: string;
  ruralCoopplanRequestDataDesc: string;
  investorOwnedUtilplanRequestDataDesc: string;
  viewAnywayFlag: boolean;
  constructor() {
    super();
    this.investorOwnedUtilVendorsNum = null;
    this.investorOwnedUtilRequestedVendorsNum = null;
    this.investorOwnedUtilReceivedVendorsNum = null;
    this.publicMuniUtilVendorsNum = null;
    this.publicMuniUtilRequestedVendorsNum = null;
    this.publicMuniUtilReceivedVendorsNum = null;
    this.ruralCoopVendorsNum = null;
    this.ruralCoopRequestedVendorsNum = null;
    this.ruralCoopReceivedVendorsNum = null;
    this.unknownTypeVendorsNum = null;
    this.unknownTypeRequestedVendorsNum = null;
    this.unknownTypeReceivedVendorsNum = null;
    this.requestDataMinVendorsDesc = null;
    this.vendorAgreementsHaveDataCollectionReqFlag = null;
    this.vendorAgreementsHaveDataCollectionReqDesc = null;
    this.clientWaiversMeetVendorRequirementsFlag = null;
    this.clientWaiversMeetVendorRequirementsDesc = null;
    this.vendorsAlertedTimelyMannerFlag = null;
    this.vendorsAlertedTimelyMannerDesc = null;
    this.deliveredFuelSmallElectricVendorFlag = null;
    this.deliveredFuelSmallElectricVendorDesc = null;
    this.smallElectricVendorCollectDataFlag = null;
    this.smallElectricVendorCollectDataDesc = null;
    this.otherReasonDesc = null;
    this.publicMuniplanRequestDataDesc = null;
    this.ruralCoopplanRequestDataDesc = null;
    this.investorOwnedUtilplanRequestDataDesc = null;
    this.viewAnywayFlag = false;
  }

  get totalNumVendors(): number {
    if (this.investorOwnedUtilVendorsNum !== null
      || this.publicMuniUtilVendorsNum !== null
      || this.ruralCoopVendorsNum !== null
      || this.unknownTypeVendorsNum !== null) {
      let totalVendors = 0;
      totalVendors += this.investorOwnedUtilVendorsNum;
      totalVendors += this.publicMuniUtilVendorsNum;
      totalVendors += this.ruralCoopVendorsNum;
      totalVendors += this.unknownTypeVendorsNum;
      return totalVendors;
    }
    else {
      return null;
    }
  }
  get totalRequestedVendors(): number {
    if (this.investorOwnedUtilRequestedVendorsNum !== null
      || this.publicMuniUtilRequestedVendorsNum !== null
      || this.ruralCoopRequestedVendorsNum !== null
      || this.unknownTypeRequestedVendorsNum !== null) {
      let totalRequested = 0;
      totalRequested += this.investorOwnedUtilRequestedVendorsNum;
      totalRequested += this.publicMuniUtilRequestedVendorsNum;
      totalRequested += this.ruralCoopRequestedVendorsNum;
      totalRequested += this.unknownTypeRequestedVendorsNum;
      return totalRequested;
    }
    else {
      return null;
    }
  }
  get totalReceivedVendors(): number {
    if (this.investorOwnedUtilReceivedVendorsNum !== null
      || this.publicMuniUtilReceivedVendorsNum !== null
      || this.ruralCoopReceivedVendorsNum !== null
      || this.unknownTypeReceivedVendorsNum !== null) {
      let totalReceived = 0;
      totalReceived += this.investorOwnedUtilReceivedVendorsNum;
      totalReceived += this.publicMuniUtilReceivedVendorsNum;
      totalReceived += this.ruralCoopReceivedVendorsNum;
      totalReceived += this.unknownTypeReceivedVendorsNum;
      return totalReceived;
    }
    else {
      return null;
    }
  }
  get statusCssString(): string {
    let status = this.totalVendorStatus;
    let className = "";
    if (status == Assessment2aStatusEnum.MeetsMinRequirement5Plus
      || status == Assessment2aStatusEnum.MeetsMinRequirementUnder5) {
      className = " green-background ";
    }
    else {
      className = " red-background ";
    }
    return className;
  }

  get totalZeroVendorString(): string {
    let zeroVendors: string[] = [];
    let zeroVendorsString: string = "";

    if (this.investorOwnedUtilVendorsNum > 0
      && this.investorOwnedUtilRequestedVendorsNum === 0) {
      zeroVendors.push("Investor-Owned Utilities")
    }
    if (this.publicMuniUtilVendorsNum > 0
      && this.publicMuniUtilRequestedVendorsNum === 0) {
      zeroVendors.push("Public Municipal Utilities")
    }
    if (this.ruralCoopVendorsNum > 0
      && this.ruralCoopRequestedVendorsNum === 0) {
      zeroVendors.push("Rural Electric Cooperatives")
    }

    if (zeroVendors.length == 0) {
      zeroVendorsString = "";
    }
    else if (zeroVendors.length == 1) {
      zeroVendorsString = " " + zeroVendors[0] + " ";
    }
    else if (zeroVendors.length == 2) {
      zeroVendorsString = " " + zeroVendors[0] + " and " + zeroVendors[1] + " ";
    }
    else if (zeroVendors.length == 3) {
      zeroVendorsString = " " + zeroVendors[0] + ",  " + zeroVendors[1] + " and " + zeroVendors[2] + " ";
    }
    return zeroVendorsString;
  }
  get totalVendorStatusString(): string {
    let totalVendors = this.totalNumVendors;
    let totalRequested = this.totalRequestedVendors;
    let totalReceived = this.totalReceivedVendors;
    let totalVendorString = "Issue found.";
    if (totalVendors === null || totalRequested === null || totalReceived === null) {
      totalVendorString = "";
    }
    //IF # of VENDORS RECEIVED MEETS THE MINIMUM (5)
    else if (totalVendors >= 5 && totalReceived >= 5) {
      totalVendorString = "No Issue – You requested and received data from at least 5 electric vendors.";
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # OF VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED = n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived == totalVendors) {
      totalVendorString = "No Issue – You requested and received data from the minimum number of electric vendors.";
    }
    //IF TOTAL # OF VENDORS ≥ 5… AND… # of VENDORS REQUESTED < 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested < 5) {
      totalVendorString = "Issue Found – You did NOT request data from the minimum required number of vendors.";
    }
    //IF TOTAL # of VENDORS ≥ 5 … AND… # of VENDORS REQUESTED ≥ 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested >= 5 && totalReceived < 5) {
      totalVendorString = "Issue Found – You did NOT receive data from the minimum required number of vendors.";
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # of VENDORS REQUESTED < n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested < totalVendors) {
      totalVendorString = "Issue Found – You did NOT request data from the minimum required number of vendors.";
    }
    //IF TOTAL #of VENDORS (n) < 5… AND… # of VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested === totalVendors && totalReceived < totalRequested) {
      totalVendorString = "Issue Found – You did NOT receive data from the minimum required number of vendors.";
    }
    return totalVendorString;
  }
  get totalVendorStatus(): number {
    let totalVendors = this.totalNumVendors;
    let totalRequested = this.totalRequestedVendors;
    let totalReceived = this.totalReceivedVendors;
    let status = -1;
    if (totalVendors === null || totalRequested === null || totalReceived === null) {
      status = -1;
    }
    //IF # of VENDORS RECEIVED MEETS THE MINIMUM (5)
    else if (totalVendors >= 5 && totalReceived >= 5) {
      status = Assessment2aStatusEnum.MeetsMinRequirement5Plus;
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # OF VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED = n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived == totalVendors) {
      status = Assessment2aStatusEnum.MeetsMinRequirementUnder5;
    }
    //IF TOTAL # OF VENDORS ≥ 5… AND… # of VENDORS REQUESTED < 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested < 5) {
      status = Assessment2aStatusEnum.RequestedUnderMin5Plus;
    }
    //IF TOTAL # of VENDORS ≥ 5 … AND… # of VENDORS REQUESTED ≥ 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested >= 5 && totalReceived < 5) {
      status = Assessment2aStatusEnum.ReceivedUnderMin5Plus;
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # of VENDORS REQUESTED < n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested < totalVendors) {
      status = Assessment2aStatusEnum.RequestedUnderMinUnder5;
    }
    //IF TOTAL #of VENDORS (n) < 5… AND… # of VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived < totalRequested) {
      status = Assessment2aStatusEnum.ReceivedUnderMinUnder5;
    }
    return status;
  }
}
export class Assessment2aStepInfo {
  sequenceNumber: number;
  showNumReq: boolean;
  showNumRec: boolean;
  showVendorReceivedStatus: boolean;
  showTotal: boolean;
  showVendorZeroError: boolean;
  constructor(sequenceNumber: number,
    showNumReq: boolean,
    showNumRec: boolean,
    showVendorReceivedStatus: boolean,
    showTotal: boolean,
    showVendorZeroError: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.showNumReq = showNumReq;
    this.showNumRec = showNumRec;
    this.showVendorReceivedStatus = showVendorReceivedStatus;
    this.showTotal = showTotal;
    this.showVendorZeroError = showVendorZeroError;
  }
}

export enum Assessment2bStepsEnum {
  EnterDataNumHouseholdsDataReceived = 0,
  ResultsOverview = 1,
  ResultsDetailElectric = 2,
  ResultsDetailNaturalGas = 3,
  ResultsDetailFuelOil = 4,
  ResultsDetailPropane = 5,
  ActionPlanSummary = 6,
}
export enum Assessment2bHHDataReceivedStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export enum Assessment2bHHServedByVendorsDataRequestedStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export enum Assessment2bHHServedByVendorsDataReceivedStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export enum Assessment2bHHWithElectricDataStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export enum Assessment2bHH12MonthBillingDataNumStatusEnum {
  OverTargetNoIssues = 0,
  NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export class Assessment2bFuelTypeInfo extends BaseAssessmentObject {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;

  totalAssistedhHNum?: number;
  hHElectricDataReceivedNum?: number;
  hHServedByVendorsDataRequestedNum?: number;
  hHServedByVendorsDataRequestedDesc: string;
  hHServedByVendorsDataReceivedNum?: number;
  hHServedByVendorsDataReceivedDesc: string;
  hHWithElectricDataNum?: number;
  hHWithElectricDataDesc: string;
  hH12MonthBillingDataNum?: number;
  improvePercenthouseholdDataColDesc: string;
  viewAnywayFlag: boolean;
  targetPercentHouseholdsCovered?: number;

  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string, targetPercentHouseholdsCovered: number) {
    super();
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.totalAssistedhHNum = null;
    this.hHElectricDataReceivedNum = null;
    this.hHServedByVendorsDataRequestedNum = null;
    this.hHServedByVendorsDataRequestedDesc = null;
    this.hHServedByVendorsDataReceivedNum = null;
    this.hHServedByVendorsDataReceivedDesc = null;
    this.hHWithElectricDataNum = null;
    this.hHWithElectricDataDesc = null;
    this.hH12MonthBillingDataNum = null;
    this.improvePercenthouseholdDataColDesc = null;
    this.viewAnywayFlag = null;
  }
  get hhDataReceivedStatus2b(): number {
    if (this.hHElectricDataReceivedNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHElectricDataReceivedNum > this.totalAssistedhHNum) {
      return Assessment2bHHDataReceivedStatusEnum.EntryError;
    }
    let hHElectricDataReceivedPct = this.roundPercent(this.hHElectricDataReceivedNum / this.totalAssistedhHNum);
    if (hHElectricDataReceivedPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment2bHHDataReceivedStatusEnum.NotMeetTarget;
    }
  }
  get hHDataReceivedPercentString(): string {
    if (this.hHElectricDataReceivedNum === null
      || this.totalAssistedhHNum === null
      || this.totalAssistedhHNum === 0) {
      return 'N/A';
    }
    let percent: number = Math.round((this.hHElectricDataReceivedNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHServedByVendorsDataRequestedStatus(): number {
    if (this.hHServedByVendorsDataRequestedNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHHServedByVendorsDataRequestedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHServedByVendorsDataRequestedNum < this.hHElectricDataReceivedNum) {
      return Assessment2bHHServedByVendorsDataRequestedStatusEnum.EntryError;
    }
    let hHServedByVendorsDataRequestedPct = this.hHServedByVendorsDataRequestedNum / this.totalAssistedhHNum;
    if (hHServedByVendorsDataRequestedPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHHServedByVendorsDataRequestedStatusEnum.OverTargetNoIssues
    }
    else {
      return Assessment2bHHServedByVendorsDataRequestedStatusEnum.NotMeetTarget;
    }
  }
  get hHServedByVendorsDataReceivedStatus(): number {
    if (this.hHServedByVendorsDataReceivedNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHHServedByVendorsDataReceivedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHServedByVendorsDataReceivedNum < this.hHElectricDataReceivedNum) {
      return Assessment2bHHServedByVendorsDataReceivedStatusEnum.EntryError;
    }
    let hHServedByVendorsDataReceivedPct = this.roundPercent(this.hHServedByVendorsDataReceivedNum / this.totalAssistedhHNum);
    if (hHServedByVendorsDataReceivedPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHHServedByVendorsDataReceivedStatusEnum.OverTargetNoIssues
    }
    else {
      return Assessment2bHHServedByVendorsDataReceivedStatusEnum.NotMeetTarget;
    }
  }
  get hHWithElectricDataStatus(): number {
    if (this.hHWithElectricDataNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHHWithElectricDataStatusEnum.NoHouseholdsServed;
    }
    if (this.hHWithElectricDataNum < this.hHElectricDataReceivedNum) {
      return Assessment2bHHWithElectricDataStatusEnum.EntryError;
    }
    let hHWithElectricDataPct = this.roundPercent(this.hHWithElectricDataNum / this.totalAssistedhHNum);
    if (hHWithElectricDataPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHHWithElectricDataStatusEnum.OverTargetNoIssues
    }
    else {
      return Assessment2bHHWithElectricDataStatusEnum.NotMeetTarget;
    }
  }
  get hH12MonthBillingDataStatus(): number {
    if (this.hH12MonthBillingDataNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHH12MonthBillingDataNumStatusEnum.NoHouseholdsServed;
    }
    if (this.hH12MonthBillingDataNum < this.hHElectricDataReceivedNum) {
      return Assessment2bHH12MonthBillingDataNumStatusEnum.EntryError;
    }
    let hH12MonthBillingDataNumPct = this.roundPercent(this.hH12MonthBillingDataNum / this.totalAssistedhHNum);
    if (hH12MonthBillingDataNumPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHH12MonthBillingDataNumStatusEnum.OverTargetNoIssues
    }
    else {
      return Assessment2bHH12MonthBillingDataNumStatusEnum.NotMeetTarget;
    }
  }

  //W = hHServedByVendorsDataNotRequestedNum = totalAssistedhHNum - hHServedByVendorsDataRequestedNum
  get hHServedByVendorsDataNotRequested(): number {
    if (this.hHServedByVendorsDataRequestedNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    return (this.totalAssistedhHNum - this.hHServedByVendorsDataRequestedNum);
  }
  //X = hHServedByVendorsDataRequestedNum - hHServedByVendorsDataReceivedNum
  get hHServedByVendorsDataNotReceived(): number {
    if (this.hHServedByVendorsDataRequestedNum === null
      || this.hHServedByVendorsDataReceivedNum === null) {
      return null;
    }
    return (this.hHServedByVendorsDataRequestedNum - this.hHServedByVendorsDataReceivedNum);
  }
  //Y = hHServedByVendorsDataReceivedNum - hHWithElectricDataNum
  get hHServedByVendorsDataNotProvidingElectricData(): number {
    if (this.hHServedByVendorsDataReceivedNum === null
      || this.hHWithElectricDataNum === null) {
      return null;
    }
    return (this.hHServedByVendorsDataReceivedNum - this.hHWithElectricDataNum);
  }
  //z = hHWithElectricDataNum - hH12MonthBillingDataNum
  get hHServedByVendorsDataNotProviding12MonthsData(): number {
    if (this.hHWithElectricDataNum === null
      || this.hH12MonthBillingDataNum === null) {
      return null;
    }
    return (this.hHWithElectricDataNum - this.hH12MonthBillingDataNum);
  }
  get targetPercentHouseholdsCoveredString(): string {
    return String(this.targetPercentHouseholdsCovered * 100) + "%";
  }

}
export class Assessment2bFuelTypesStatusHolder {
  Electric: Assessment2bFuelTypeInfo;
  NaturalGas: Assessment2bFuelTypeInfo;
  FuelOil: Assessment2bFuelTypeInfo;
  Propane: Assessment2bFuelTypeInfo;
  FiscalYear: number;
  Grantee: number;
  constructor() {
    this.Electric = new Assessment2bFuelTypeInfo("Electric", "Electric", "Electric", "Electric", 0.5);
    this.NaturalGas = new Assessment2bFuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 0.5);
    this.FuelOil = new Assessment2bFuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 0.2);
    this.Propane = new Assessment2bFuelTypeInfo("Propane", "Propane", "Propane", "Propane", 0.2);
  }
}
export class Assessment2bStepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showDataReceivedStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showDataReceivedStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showDataReceivedStatus = showDataReceivedStatus;
  }
}

export enum Assessment3aStepsEnum {
  EnterDataNumHouseholds = 0,
  EnterDataNumHouseholdsVendorAssigned = 1,
  VendorAssignedStatus = 2,
  VendorAssignedFollowupElectric = 3,
  VendorAssignedFollowupNaturalGas = 4,
  VendorAssignedFollowupFuelOil = 5,
  VendorAssignedFollowupPropane = 6,
  ActionPlanSummary = 7,
}
export enum Assessment3aVendorAssignedStatusEnum {
  Over95NoIssues = 0,
  Under95NotMeetTarget = 1,
  NoHouseholdsServed = 2,
  EntryError = 3,
}
export class Assessment3aFuelTypeInfo extends BaseAssessmentObject {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  targetPercentHouseholdsCovered: number;
  totalAssistedhHNum: number;
  hHAssignedVendorNum: number;
  appIncludesVendorAndAcctNoFlag: boolean;
  appIncludesVendorAndAcctNoDesc: string;
  appVendorAndAcctNoRequiredFieldFlag: boolean;
  appVendorAndAcctNoRequiredFieldDesc: string;
  intakeFollowupMissingVendorFlag: boolean;
  intakeFollowupMissingVendorDesc: string;
  otherReasonDesc: string;
  viewAnywayFlag: boolean;

  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string, targetPercentHouseholdsCovered: number) {
    super();
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.totalAssistedhHNum = null;
    this.hHAssignedVendorNum = null;
    this.appIncludesVendorAndAcctNoFlag = null;
    this.appIncludesVendorAndAcctNoDesc = null;
    this.appVendorAndAcctNoRequiredFieldFlag = null;
    this.appVendorAndAcctNoRequiredFieldDesc = null;
    this.intakeFollowupMissingVendorFlag = null;
    this.intakeFollowupMissingVendorDesc = null;
    this.otherReasonDesc = null;
    this.viewAnywayFlag = null;
  }
  get vendorAssignmentStatus(): number {
    if (this.totalAssistedhHNum === null
      || this.hHAssignedVendorNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHAssignedVendorNum > this.totalAssistedhHNum) {
      return Assessment3aVendorAssignedStatusEnum.EntryError;
    }
    if (this.roundPercent(this.hHAssignedVendorNum / this.totalAssistedhHNum) >= 0.95) {
      return Assessment3aVendorAssignedStatusEnum.Over95NoIssues;
    }
    else {
      return Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget;
    }
  }
  get vendorAssignmentPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHAssignedVendorNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHAssignedVendorNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get targetPercentHouseholdsCoveredString(): string {
    let percent: number = Math.round((this.targetPercentHouseholdsCovered) * 100);
    return String(percent) + "%";
  }
}
export class Assessment3aFuelTypesStatusHolder {
  Electric: Assessment3aFuelTypeInfo;
  NaturalGas: Assessment3aFuelTypeInfo;
  FuelOil: Assessment3aFuelTypeInfo;
  Propane: Assessment3aFuelTypeInfo;
  FiscalYear: number;
  Grantee: number;
  constructor() {
    this.Electric = new Assessment3aFuelTypeInfo("Electric", "Electric", "Electric", "Electric", 0.95);
    this.NaturalGas = new Assessment3aFuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 0.95);
    this.FuelOil = new Assessment3aFuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 0.95);
    this.Propane = new Assessment3aFuelTypeInfo("Propane", "Propane", "Propane", "Propane", 0.95);
  }
}
export class Assessment3aStepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showVendorAssignedEntry: boolean;
  showVendorAssignedStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showVendorAssignedEntry: boolean,
    showVendorAssignedStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showVendorAssignedEntry = showVendorAssignedEntry
    this.showVendorAssignedStatus = showVendorAssignedStatus;
  }
}

export enum Assessment3bStepsEnum {
  EnterDataNumHouseholds = 0,
  NumHouseholdsBothHeatAndElectric = 1,
  NumHouseholdsMainHeatData = 2,
  NumHouseholdsElectricData = 3,
  ResultsOverview = 4,
  AccountMatchingNaturalGas = 5,
  AccountMatchingFuelOil = 6,
  AccountMatchingPropane = 7,
  ActionPlanSummary = 8,
}
export enum Assessment3bDataReceivedStatusEnum {
  OverTargetNoIssues = 1,
  ElecticunderTarget = 2,
  MainHeatUnderTarget = 3,
  HhWithBothUnderTarget = 4,
  NeitherOverTarget = 5,
  NoHouseholdsServed = 6,
  EntryError = 7,
}
export class Assessment3bFuelTypeInfo extends BaseAssessmentObject {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  targetPercentHouseholdsCovered: number;
  totalAssistedhHNum: number;
  hHMainHeatDataNum: number;
  hHElecticDataNum: number;
  hHElecticAndMainHeatDataNum: number;
  appVendorNameAndAccountNoFlag: boolean;
  appVendorNameAndAccountNoDesc: string;
  clientWaiversMeetElectricVendorRequirementsFlag: boolean;
  clientWaiversMeetElectricVendorRequirementsDesc: string;
  electricVendorRequestedServeTargetPercentHhFlag: boolean;
  electricVendorRequestedServeTargetPercentHhDesc: string;
  electricVendorProvidedServeTargetPercentHhFlag: boolean;
  electricVendorProvidedServeTargetPercentHhDesc: string;
  electricBillingDataTargetPercentHhFlag: boolean;
  electricBillingDataTargetPercentHhDesc: string;
  vendorsSupplyDataNonElectricHhFlag: boolean;
  vendorsSupplyDataNonElectricHhDesc: string;
  otherReasonMainHeatDesc: string;
  clientWaiversMeetHeatVendorRequirementsFlag: boolean;
  clientWaiversMeetHeatVendorRequirementsDesc: string;
  heatVendorRequestedServeTargetPercentHhFlag: boolean;
  heatVendorRequestedServeTargetPercentHhDesc: string;
  heatVendorProvidedServeTargetPercentHhFlag: boolean;
  heatVendorProvidedServeTargetPercentHhDesc: string;
  heatBillingDataTargetPercentHhFlag: boolean;
  heatBillingDataTargetPercentHhDesc: string;
  heatBillingDataIncluesAcctNoFlag: boolean;
  heatBillingDataIncluesAcctNoDesc: string;
  electricBillingDataIncluesAcctNoFlag: boolean;
  electricBillingDataIncluesAcctNoDesc: string;
  hhUniqueIdAssignedFlag: boolean;
  hhUniqueIdAssignedDesc: string;
  otherReasonMatchingDesc: string;
  viewAnywayFlag: boolean;

  constructor(name: string, description: string, descriptionHeat: string, descriptionHeating: string, targetPercentHouseholdsCovered: number) {
    super();
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.totalAssistedhHNum = null;
    this.hHMainHeatDataNum = null;
    this.hHElecticDataNum = null;
    this.hHElecticAndMainHeatDataNum = null;

    this.appVendorNameAndAccountNoFlag = null;
    this.appVendorNameAndAccountNoDesc = null;
    this.clientWaiversMeetElectricVendorRequirementsFlag = null;
    this.clientWaiversMeetElectricVendorRequirementsDesc = null;
    this.electricVendorRequestedServeTargetPercentHhFlag = null;
    this.electricVendorRequestedServeTargetPercentHhDesc = null;
    this.electricVendorProvidedServeTargetPercentHhFlag = null;
    this.electricVendorProvidedServeTargetPercentHhDesc = null;
    this.electricBillingDataTargetPercentHhFlag = null;
    this.electricBillingDataTargetPercentHhDesc = null;
    this.vendorsSupplyDataNonElectricHhFlag = null;
    this.vendorsSupplyDataNonElectricHhDesc = null;
    this.otherReasonMainHeatDesc = null;
    this.clientWaiversMeetHeatVendorRequirementsFlag = null;
    this.clientWaiversMeetHeatVendorRequirementsDesc = null;
    this.heatVendorRequestedServeTargetPercentHhFlag = null;
    this.heatVendorRequestedServeTargetPercentHhDesc = null;
    this.heatVendorProvidedServeTargetPercentHhFlag = null;
    this.heatVendorProvidedServeTargetPercentHhDesc = null;
    this.heatBillingDataTargetPercentHhFlag = null;
    this.heatBillingDataTargetPercentHhDesc = null;
    this.heatBillingDataIncluesAcctNoFlag = null;
    this.heatBillingDataIncluesAcctNoDesc = null;
    this.electricBillingDataIncluesAcctNoFlag = null;
    this.electricBillingDataIncluesAcctNoDesc = null;
    this.hhUniqueIdAssignedFlag = null;
    this.hhUniqueIdAssignedDesc = null;
    this.otherReasonMatchingDesc = null;
    this.viewAnywayFlag = null;
  }
  get hhDataReceivedStatus3b(): number {
    if (this.totalAssistedhHNum === null
      || this.hHMainHeatDataNum === null
      || this.hHElecticDataNum === null
      || this.hHElecticAndMainHeatDataNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment3bDataReceivedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHMainHeatDataNum > this.totalAssistedhHNum
      || this.hHElecticDataNum > this.totalAssistedhHNum
      || this.hHElecticAndMainHeatDataNum > this.totalAssistedhHNum
      || this.hHElecticAndMainHeatDataNum > this.hHMainHeatDataNum
      || this.hHElecticAndMainHeatDataNum > this.hHElecticDataNum) {
      return Assessment3bDataReceivedStatusEnum.EntryError;
    }

    //get percent households with electric data
    let percentHhWithElectricData = this.roundPercent(this.hHElecticDataNum / this.totalAssistedhHNum);
    //get percent households with main heat data
    let percentHhWithMainHeatData = this.roundPercent(this.hHMainHeatDataNum / this.totalAssistedhHNum);
    //get percent households with both data
    let percentHhWithElecticAndMainHeatData = this.roundPercent(this.hHElecticAndMainHeatDataNum / this.totalAssistedhHNum);


    //A. IF # OF HOUSEHOLDS WITH BOTH KINDS OF DATA > {50% | 20%}
    if (percentHhWithElecticAndMainHeatData >= this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.OverTargetNoIssues;
    }

    //B. IF # of HHs WITH MAIN HEATING DATA > {50% | 20%} BUT NUMBER OF HOUSEHOLDS WITH ELECTRIC DATA NOT
    if (percentHhWithMainHeatData >= this.targetPercentHouseholdsCovered
      && percentHhWithElectricData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.ElecticunderTarget;
    }
    //C. IF # of HHs WITH ELECTRIC DATA > {50% | 20%} BUT NUMBER OF HOUSEHOLDS WITH MAIN HEATING DATA NOT
    if (percentHhWithElectricData >= this.targetPercentHouseholdsCovered
      && percentHhWithMainHeatData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget;
    }

    //D. IF # of HHs WITH ELECTRIC DATA > {50% | 20%} AND # of HHs WITH HEATING DATA > {50% | 20%} BUT #
    //of HHs WITH BOTH HEATING AND ELECTRIC DATA < {50% | 20%}
    if (percentHhWithMainHeatData >= this.targetPercentHouseholdsCovered
      && percentHhWithElectricData >= this.targetPercentHouseholdsCovered
      && percentHhWithElecticAndMainHeatData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget;
    }

    if (percentHhWithMainHeatData < this.targetPercentHouseholdsCovered
      && percentHhWithElectricData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.NeitherOverTarget;
    }
  }
  get targetPercentHouseholdsCoveredString(): string {
    return String(this.targetPercentHouseholdsCovered * 100) + "%";
  }
  get hhDataReceivedStatusString3b(): string {
    const statusNumber: number = this.hhDataReceivedStatus3b;
    switch (statusNumber) {
      case Assessment3bDataReceivedStatusEnum.OverTargetNoIssues:
        return `<strong>No Issue –</strong> You collected 12 months of main heating and electric baseload for at least ${this.targetPercentHouseholdsCoveredString} of these households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.ElecticunderTarget:
        return `<strong>Issue Found –</strong> You collected main heating data for a sufficient number of ${this.description} but DID NOT collect electric baseload data for as sufficient number of  ${this.description}  households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget:
        return `<strong>Issue Found –</strong> You collected electric baseload data for a sufficient number of ${this.description} but DID NOT collect main heating data for as sufficient number of ${this.description} households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget:
        return `<strong>Issue Found –</strong> You collected electric baseload and main heat data for a sufficient number of ${this.description} households but you do not have BOTH for as sufficient number of ${this.description} households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.NeitherOverTarget:
        return `<strong>Issue Found –</strong> You DID NOT collect enough data for either main heating fuel expenditures or electric baseload expenditures for households that heat with  ${this.description}.`;
        break;
      case Assessment3bDataReceivedStatusEnum.NoHouseholdsServed:
        return `<strong>N/A –</strong> You did not serve households with this fuel.`;
        break;
      case Assessment3bDataReceivedStatusEnum.EntryError:
        if (this.totalAssistedhHNum < this.hHElecticAndMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have both types of energy data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.totalAssistedhHNum < this.hHMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of main heating billing data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.totalAssistedhHNum < this.hHElecticDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of electric baseload billing data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.hHMainHeatDataNum < this.hHElecticAndMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of main heating billing data CANNOT be less than the number of households for whom you have both types of energy data.`;
        }
        if (this.hHElecticDataNum < this.hHElecticAndMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of electric baseload billing data CANNOT be less than the number of households for whom you have both types of energy data.`;
        }
        return `<strong>Issue Found –</strong> Data entry error.`;
        break;
      default:
        return "N/A";
    }
  }
  get hhDataReceivedStatusClassname3b(): string {
    const statusNumber: number = this.hhDataReceivedStatus3b;
    switch (statusNumber) {
      case Assessment3bDataReceivedStatusEnum.OverTargetNoIssues:
        return " green-background ";
        break;
      case Assessment3bDataReceivedStatusEnum.ElecticunderTarget:
      case Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget:
      case Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget:
      case Assessment3bDataReceivedStatusEnum.NeitherOverTarget:
      case Assessment3bDataReceivedStatusEnum.EntryError:
        return " red-background ";
        break;
      case Assessment3bDataReceivedStatusEnum.NoHouseholdsServed:
      default:
        return "";
    }
  }
  get hHMainHeatDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHMainHeatDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHMainHeatDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHElectricDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHElecticDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHElecticDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHBothDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHElecticAndMainHeatDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHElecticAndMainHeatDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
}
export class Assessment3bFuelTypesStatusHolder {
  NaturalGas: Assessment3bFuelTypeInfo;
  FuelOil: Assessment3bFuelTypeInfo;
  Propane: Assessment3bFuelTypeInfo;
  FiscalYear: number;
  Grantee: number;
  constructor() {
    this.NaturalGas = new Assessment3bFuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 0.5);
    this.FuelOil = new Assessment3bFuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 0.2);
    this.Propane = new Assessment3bFuelTypeInfo("Propane", "Propane", "Propane", "Propane", 0.2);
  }
}
export class Assessment3bStepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showMainHeatAndElectric: boolean;
  showMainHeat: boolean;
  showElectricBaseload: boolean;
  //# Households with Billing Data for Both  Main Heating and Electric Baseload 	
  //# of Households with Main Heating Fuel Data Available Pct	
  //# of Households with Electric Baseload Data Available Pct
  //Status
  showBothAndNumAndPctAndStatus: boolean;
  constructor(sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showMainHeatAndElectric: boolean,
    showMainHeat: boolean,
    showElectricBaseload: boolean,
    showBothAndNumAndPctAndStatus: boolean) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showMainHeatAndElectric = showMainHeatAndElectric;
    this.showMainHeat = showMainHeat;
    this.showElectricBaseload = showElectricBaseload;
    this.showBothAndNumAndPctAndStatus = showBothAndNumAndPctAndStatus;
  }
}

export enum Assessment4StepsEnum {
  Q1TrackAcctNoFormat = 0,
  Q2TrackPercentAccountNo = 1,
  Q3TractPercentVendorNotFind = 2,
  Q4IdLargestVendors = 3,
  Q5TrackVendorCompliance = 4,
  Q6ExcludeNot12MoData = 5,
  Q7CheckOutliers = 6,
  Q8ProcessReviewFindings = 7,
  Q9AddingChecks = 8,
  Q10RemovingChecks = 9,
  ActionPlanSummary = 10,
}
export class Assessment4Model extends BaseAssessmentObject {
  FiscalYear: number;
  Grantee: number;
  trackPctHHAcctNoFlag: boolean;
  trackPctHHAcctNoDesc: string;
  trackPctHHVendorNotFindFlag: boolean;
  trackPctHHVendorNotFindDesc: string;
  processIdentifyLargestElectricVendorsFlag: boolean;
  processIdentifyLargestElectricVendorsDesc: string;
  processTrackVendorComplianceFlag: boolean;
  processTrackVendorComplianceDesc: string;
  trackVendorDataCompleteFlag: boolean;
  trackVendorDataCompleteDesc: string;
  useTrackingToSelectVendorsFlag: boolean;
  useTrackingToSelectVendorsDesc: string;
  excludeHhNot12MonthsDataFlag: boolean;
  excludeHhNot12MonthsDataDesc: string;
  checkAndReportOutliersFlag: boolean;
  checkAndReportOutliersDesc: string;
  processReviewFindingsFlag: boolean;
  processReviewFindingsDesc: string;
  processAddChecksFlag: boolean;
  processAddChecksDesc: string;
  processRemoveChecksFlag: boolean;
  processRemoveChecksDesc: string;

  trackAcctNoFormatFlag: boolean;
  trackAcctNoFormatDesc: string;
  trackMissingAcctNoCertainAgenciesFlag: boolean;
  trackMissingAcctNoCertainAgenciesDesc: string;
  trackNotFindCertainAgenciesFlag: boolean;
  trackNotFindCertainAgenciesDesc: string;
  processChooseVendorsBaseDiffHeatFlag: boolean;
  processChooseVendorsBaseDiffHeatDesc: string;
  constructor() {
    super();
    this.trackPctHHAcctNoFlag = null;
    this.trackPctHHAcctNoDesc = null;
    this.trackPctHHVendorNotFindFlag = null;
    this.trackPctHHVendorNotFindDesc = null;
    this.processIdentifyLargestElectricVendorsFlag = null;
    this.processIdentifyLargestElectricVendorsDesc = null;
    this.processTrackVendorComplianceFlag = null;
    this.processTrackVendorComplianceDesc = null;
    this.trackVendorDataCompleteFlag = null;
    this.trackVendorDataCompleteDesc = null;
    this.useTrackingToSelectVendorsFlag = null;
    this.useTrackingToSelectVendorsDesc = null;
    this.excludeHhNot12MonthsDataFlag = null;
    this.excludeHhNot12MonthsDataDesc = null;
    this.checkAndReportOutliersFlag = null;
    this.checkAndReportOutliersDesc = null;
    this.processReviewFindingsFlag = null;
    this.processReviewFindingsDesc = null;
    this.processAddChecksFlag = null;
    this.processAddChecksDesc = null;
    this.processRemoveChecksFlag = null;
    this.processRemoveChecksDesc = null;
    this.trackAcctNoFormatFlag = null;
    this.trackAcctNoFormatDesc = null;
    this.trackMissingAcctNoCertainAgenciesFlag = null;
    this.trackMissingAcctNoCertainAgenciesDesc = null;
    this.trackNotFindCertainAgenciesFlag = null;
    this.trackNotFindCertainAgenciesDesc = null;
    this.processChooseVendorsBaseDiffHeatFlag = null;
    this.processChooseVendorsBaseDiffHeatDesc = null;
  }
}
export class Assessment4StepInfo {
  sequenceNumber: number;
  constructor(sequenceNumber: number) {
    this.sequenceNumber = sequenceNumber;
  }
}

export enum OverallAssessmentSedsStatusEnum {
  InRangeNoIssues = 0,
  OutOfRange = 1,
  ZeroAverageExpenditure = 2,
  NoSEDSData = 3,
}
export enum OverallAssessmentStepsEnum {
  Assessment1EnterData = 0,
  Assessment1Results = 1,
  Assessment2AEnterData = 2,
  Assessment2AResults = 3,
  Assessment2BEnterData = 4,
  Assessment2BResults = 5,
  Assessment3AEnterData = 6,
  Assessment3AResults = 7,
  Assessment3BEnterData = 8,
  Assessment3BResults = 9,
  Assessment4EnterData = 10,
  Assessment4Results = 11,
  ResultsOverview = 12,
}
export class OverallAssessmentFuelTypeInfo extends BaseAssessmentObject {
  name: string;
  description: string;
  descriptionHeat: string;
  descriptionHeating: string;
  targetPercentHouseholdsCovered: number;
  computedAverageExpenditure?: number;
  sedsElectricNonHeatExpenditure?: number;
  sedsElectricNonHeatCode: string;
  totalAssistedhHNum?: number;
  hHElectricDataReceivedNum?: number;
  hHAssignedVendorNum: number;
  hHMainHeatDataNum: number;
  hHElecticDataNum: number;
  hHElecticAndMainHeatDataNum: number;
  constructor(name: string
    , description: string
    , descriptionHeat: string
    , descriptionHeating: string
    , targetPercentHouseholdsCovered: number) {
    super();
    this.name = name;
    this.description = description;
    this.descriptionHeat = descriptionHeat;
    this.descriptionHeating = descriptionHeating;
    this.targetPercentHouseholdsCovered = targetPercentHouseholdsCovered;
    this.computedAverageExpenditure = null;
    this.sedsElectricNonHeatExpenditure = null;
    this.totalAssistedhHNum = null;
    this.hHElectricDataReceivedNum = null;
    this.hHAssignedVendorNum = null;
    this.hHMainHeatDataNum = null;
    this.hHElecticDataNum = null;
    this.hHElecticAndMainHeatDataNum = null;
  }
  get percentOfSedsStatus(): number {
    if (this.sedsElectricNonHeatExpenditure === 0 || this.sedsElectricNonHeatExpenditure === null) {
      return Assessment1FuelStatusEnum.NoSEDSData;
    }
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure == 0) {
      return Assessment1FuelStatusEnum.ZeroAverageExpenditure;
    }
    else if (this.roundPercent(this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) < 0.5) {
      return Assessment1FuelStatusEnum.UnderMin;
    }
    else if (this.roundPercent(this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) > 1.5) {
      return Assessment1FuelStatusEnum.OverMax
    }
    else {
      return Assessment1FuelStatusEnum.InRangeNoIssues
    }
  }
  get percentOfSedsString(): string {
    if (this.computedAverageExpenditure === null || this.computedAverageExpenditure === 0) {
      return 'N/A';
    }
    else if (this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return 'N/A';
    }
    let percent: number = Math.round((this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) * 100);
    return String(percent) + "%";
  }
  get percentSpendingLessString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return null;
    }
    let percent: number = Math.round((1 - (this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure)) * 100);
    return String(percent) + "%";
  }
  get percentSpendingMoreString(): string {
    if (this.computedAverageExpenditure === null
      || this.sedsElectricNonHeatExpenditure === 0
      || this.sedsElectricNonHeatExpenditure === null) {
      return null;
    }
    let percent: number = Math.round(((this.computedAverageExpenditure / this.sedsElectricNonHeatExpenditure) - 1) * 100);
    return String(percent) + "%";
  }
  get vendorAssignmentStatus(): number {
    if (this.totalAssistedhHNum === null
      || this.hHAssignedVendorNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHAssignedVendorNum > this.totalAssistedhHNum) {
      return Assessment3aVendorAssignedStatusEnum.EntryError;
    }
    if (this.roundPercent(this.hHAssignedVendorNum / this.totalAssistedhHNum) >= 0.95) {
      return Assessment3aVendorAssignedStatusEnum.Over95NoIssues;
    }
    else {
      return Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget;
    }
  }
  get vendorAssignmentPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHAssignedVendorNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHAssignedVendorNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hhDataReceivedStatus2b(): number {
    if (this.hHElectricDataReceivedNum === null
      || this.totalAssistedhHNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHElectricDataReceivedNum > this.totalAssistedhHNum) {
      return Assessment2bHHDataReceivedStatusEnum.EntryError;
    }
    let hHElectricDataReceivedPct = this.roundPercent(this.hHElectricDataReceivedNum / this.totalAssistedhHNum);
    if (hHElectricDataReceivedPct >= this.targetPercentHouseholdsCovered) {
      return Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues;
    }
    else {
      return Assessment2bHHDataReceivedStatusEnum.NotMeetTarget;
    }
  }
  get targetPercentHouseholdsCoveredString(): string {
    return String(this.targetPercentHouseholdsCovered * 100) + "%";
  }
  get hhDataReceivedStatus3b(): number {
    if (this.totalAssistedhHNum === null
      || this.hHMainHeatDataNum === null
      || this.hHElecticDataNum === null
      || this.hHElecticAndMainHeatDataNum === null) {
      return null;
    }
    if (this.totalAssistedhHNum === 0) {
      return Assessment3bDataReceivedStatusEnum.NoHouseholdsServed;
    }
    if (this.hHMainHeatDataNum > this.totalAssistedhHNum
      || this.hHElecticDataNum > this.totalAssistedhHNum
      || this.hHElecticAndMainHeatDataNum > this.totalAssistedhHNum
      || this.hHElecticAndMainHeatDataNum > this.hHMainHeatDataNum
      || this.hHElecticAndMainHeatDataNum > this.hHElecticDataNum) {
      return Assessment3bDataReceivedStatusEnum.EntryError;
    }

    //get percent households with electric data
    let percentHhWithElectricData = this.roundPercent(this.hHElecticDataNum / this.totalAssistedhHNum);
    //get percent households with main heat data
    let percentHhWithMainHeatData = this.roundPercent(this.hHMainHeatDataNum / this.totalAssistedhHNum);
    //get percent households with both data
    let percentHhWithElecticAndMainHeatData = this.roundPercent(this.hHElecticAndMainHeatDataNum / this.totalAssistedhHNum);


    //A. IF # OF HOUSEHOLDS WITH BOTH KINDS OF DATA > {50% | 20%}
    if (percentHhWithElecticAndMainHeatData >= this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.OverTargetNoIssues;
    }

    //B. IF # of HHs WITH MAIN HEATING DATA > {50% | 20%} BUT NUMBER OF HOUSEHOLDS WITH ELECTRIC DATA NOT
    if (percentHhWithMainHeatData >= this.targetPercentHouseholdsCovered
      && percentHhWithElectricData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.ElecticunderTarget;
    }
    //C. IF # of HHs WITH ELECTRIC DATA > {50% | 20%} BUT NUMBER OF HOUSEHOLDS WITH MAIN HEATING DATA NOT
    if (percentHhWithElectricData >= this.targetPercentHouseholdsCovered
      && percentHhWithMainHeatData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget;
    }

    //D. IF # of HHs WITH ELECTRIC DATA > {50% | 20%} AND # of HHs WITH HEATING DATA > {50% | 20%} BUT #
    //of HHs WITH BOTH HEATING AND ELECTRIC DATA < {50% | 20%}
    if (percentHhWithMainHeatData >= this.targetPercentHouseholdsCovered
      && percentHhWithElectricData >= this.targetPercentHouseholdsCovered
      && percentHhWithElecticAndMainHeatData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget;
    }

    if (percentHhWithMainHeatData < this.targetPercentHouseholdsCovered
      && percentHhWithElectricData < this.targetPercentHouseholdsCovered) {
      return Assessment3bDataReceivedStatusEnum.NeitherOverTarget;
    }
  }
  get hhDataReceivedStatusString3b(): string {
    const statusNumber: number = this.hhDataReceivedStatus3b;
    switch (statusNumber) {
      case Assessment3bDataReceivedStatusEnum.OverTargetNoIssues:
        return `<strong>No Issue –</strong> You collected 12 months of main heating and electric baseload for at least ${this.targetPercentHouseholdsCoveredString} of these households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.ElecticunderTarget:
        return `<strong>Issue Found –</strong> You collected main heating data for a sufficient number of ${this.description} but DID NOT collect electric baseload data for as sufficient number of  ${this.description}  households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget:
        return `<strong>Issue Found –</strong> You collected electric baseload data for a sufficient number of ${this.description} but DID NOT collect main heating data for as sufficient number of ${this.description} households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget:
        return `<strong>Issue Found –</strong> You collected electric baseload and main heat data for a sufficient number of ${this.description} households but you do not have BOTH for as sufficient number of ${this.description} households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.NeitherOverTarget:
        return `<strong>Issue Found –</strong> You did not collect electric baseload or main heating data for a sufficient number of ${this.description}  households.`;
        break;
      case Assessment3bDataReceivedStatusEnum.NoHouseholdsServed:
        return `<strong>N/A –</strong> You did not serve households with this fuel.`;
        break;
      case Assessment3bDataReceivedStatusEnum.EntryError:
        if (this.totalAssistedhHNum < this.hHElecticAndMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have both types of energy data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.totalAssistedhHNum < this.hHMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of main heating billing data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.totalAssistedhHNum < this.hHElecticDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of electric baseload billing data CANNOT be greater than the total number of assisted households.`;
        }
        if (this.hHMainHeatDataNum < this.hHElecticAndMainHeatDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of main heating billing data CANNOT be less than the number of households for whom you have both types of energy data.`;
        }
        if (this.totalAssistedhHNum < this.hHElecticDataNum) {
          return `<strong>Data Entry Error</strong> - the number of households for whom you have collected 12 consecutive months of electric baseload billing data CANNOT be less than the number of households for whom you have both types of energy data.`;
        }
        return `<strong>Issue Found –</strong> Data entry error.`;
        break;
      default:
        return "N/A";
    }
  }
  get hhDataReceivedStatusClassname3b(): string {
    const statusNumber: number = this.hhDataReceivedStatus3b;
    switch (statusNumber) {
      case Assessment3bDataReceivedStatusEnum.OverTargetNoIssues:
        return " green-background ";
        break;
      case Assessment3bDataReceivedStatusEnum.ElecticunderTarget:
      case Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget:
      case Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget:
      case Assessment3bDataReceivedStatusEnum.NeitherOverTarget:
      case Assessment3bDataReceivedStatusEnum.EntryError:
        return " red-background ";
        break;
      case Assessment3bDataReceivedStatusEnum.NoHouseholdsServed:
      default:
        return "";
    }
  }
  get hHDataReceivedPercentString(): string {
    if (this.hHElectricDataReceivedNum === null
      || this.totalAssistedhHNum === null
      || this.totalAssistedhHNum === 0) {
      return 'N/A';
    }
    let percent: number = Math.round((this.hHElectricDataReceivedNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHMainHeatDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHMainHeatDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHMainHeatDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHElectricDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHElecticDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHElecticDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
  get hHBothDataReceivedPercentString(): string {
    if (this.totalAssistedhHNum == null
      || this.totalAssistedhHNum == 0
      || this.hHElecticAndMainHeatDataNum == null) {
      return null;
    }
    let percent: number = Math.round((this.hHElecticAndMainHeatDataNum / this.totalAssistedhHNum) * 100);
    return String(percent) + "%";
  }
}
export class OverallAssessmentFuelTypesStatusHolder {
  Electric: OverallAssessmentFuelTypeInfo;
  NaturalGas: OverallAssessmentFuelTypeInfo;
  FuelOil: OverallAssessmentFuelTypeInfo;
  Propane: OverallAssessmentFuelTypeInfo;
  FiscalYear: number;
  Grantee: number;
  investorOwnedUtilVendorsNum?: number;
  investorOwnedUtilRequestedVendorsNum?: number;
  investorOwnedUtilReceivedVendorsNum?: number;
  publicMuniUtilVendorsNum?: number;
  publicMuniUtilRequestedVendorsNum?: number;
  publicMuniUtilReceivedVendorsNum?: number;
  ruralCoopVendorsNum?: number;
  ruralCoopRequestedVendorsNum?: number;
  ruralCoopReceivedVendorsNum?: number;
  unknownTypeVendorsNum?: number;
  unknownTypeRequestedVendorsNum?: number;
  unknownTypeReceivedVendorsNum?: number;
  checkAgenciesCollectDataEveryClientFlag?: string;
  checkVendorsSupplyDataEveryClientFlag?: string;
  checksIdenfityErrorsFlag?: string;
  processReviewFindingsFlag?: string;
  processReviewChecksFlag?: string;
  constructor() {
    this.Electric = new OverallAssessmentFuelTypeInfo("Electric", "Electric", "Electric", "Electric", 0.5);
    this.NaturalGas = new OverallAssessmentFuelTypeInfo("NaturalGas", "Natural Gas", "Natural Gas", "Natural Gas", 0.5);
    this.FuelOil = new OverallAssessmentFuelTypeInfo("FuelOil", "Fuel Oil", "Fuel Oil", "Fuel Oil", 0.2);
    this.Propane = new OverallAssessmentFuelTypeInfo("Propane", "Propane", "Propane", "Propane", 0.2);
    this.FiscalYear = null;
    this.Grantee = null;
    this.investorOwnedUtilVendorsNum = null;
    this.investorOwnedUtilRequestedVendorsNum = null;
    this.investorOwnedUtilReceivedVendorsNum = null;
    this.publicMuniUtilVendorsNum = null;
    this.publicMuniUtilRequestedVendorsNum = null;
    this.publicMuniUtilReceivedVendorsNum = null;
    this.ruralCoopVendorsNum = null;
    this.ruralCoopRequestedVendorsNum = null;
    this.ruralCoopReceivedVendorsNum = null;
    this.unknownTypeVendorsNum = null;
    this.unknownTypeRequestedVendorsNum = null;
    this.unknownTypeReceivedVendorsNum = null;
    this.checkAgenciesCollectDataEveryClientFlag = null;
    this.checkVendorsSupplyDataEveryClientFlag = null;
    this.checksIdenfityErrorsFlag = null;
    this.processReviewFindingsFlag = null;
    this.processReviewChecksFlag = null;
  }
  get assessment1OverallStatus(): number {

    let status: number = 0;
    if (this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
      && this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
      && this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
    ) {
      status = OverallAssessmentSedsStatusEnum.InRangeNoIssues;
    }
    else if (this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
    ) {
      status = OverallAssessmentSedsStatusEnum.OutOfRange;
    }
    else if (this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
    ) {
      status = OverallAssessmentSedsStatusEnum.ZeroAverageExpenditure;
    }
    else if (this.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
      || this.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
      || this.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
    ) {
      status = OverallAssessmentSedsStatusEnum.NoSEDSData;
    }

    return status;
  }
  get totalNumVendors(): number {
    if (this.investorOwnedUtilVendorsNum !== null
      || this.publicMuniUtilVendorsNum !== null
      || this.ruralCoopVendorsNum !== null
      || this.unknownTypeVendorsNum !== null) {
      let totalVendors = 0;
      totalVendors += this.investorOwnedUtilVendorsNum;
      totalVendors += this.publicMuniUtilVendorsNum;
      totalVendors += this.ruralCoopVendorsNum;
      totalVendors += this.unknownTypeVendorsNum;
      return totalVendors;
    }
    else {
      return null;
    }
  }
  get totalRequestedVendors(): number {
    if (this.investorOwnedUtilRequestedVendorsNum !== null
      || this.publicMuniUtilRequestedVendorsNum !== null
      || this.ruralCoopRequestedVendorsNum !== null
      || this.unknownTypeRequestedVendorsNum !== null) {
      let totalRequested = 0;
      totalRequested += this.investorOwnedUtilRequestedVendorsNum;
      totalRequested += this.publicMuniUtilRequestedVendorsNum;
      totalRequested += this.ruralCoopRequestedVendorsNum;
      totalRequested += this.unknownTypeRequestedVendorsNum;
      return totalRequested;
    }
    else {
      return null;
    }
  }
  get totalReceivedVendors(): number {
    if (this.investorOwnedUtilReceivedVendorsNum !== null
      || this.publicMuniUtilReceivedVendorsNum !== null
      || this.ruralCoopReceivedVendorsNum !== null
      || this.unknownTypeReceivedVendorsNum !== null) {
      let totalReceived = 0;
      totalReceived += this.investorOwnedUtilReceivedVendorsNum;
      totalReceived += this.publicMuniUtilReceivedVendorsNum;
      totalReceived += this.ruralCoopReceivedVendorsNum;
      totalReceived += this.unknownTypeReceivedVendorsNum;
      return totalReceived;
    }
    else {
      return null;
    }
  }
  get statusCssString(): string {
    let status = this.totalVendorStatus;
    let className = "";
    if (status == Assessment2aStatusEnum.MeetsMinRequirement5Plus
      || status == Assessment2aStatusEnum.MeetsMinRequirementUnder5) {
      className = " green-background ";
    }
    else {
      className = " red-background ";
    }
    return className;
  }
  get totalZeroVendorString(): string {
    let zeroVendors: string[] = [];
    let zeroVendorsString: string = "";

    if (this.investorOwnedUtilVendorsNum > 0
      && this.investorOwnedUtilRequestedVendorsNum === 0) {
      zeroVendors.push("Investor-Owned Utilities")
    }
    if (this.publicMuniUtilVendorsNum > 0
      && this.publicMuniUtilRequestedVendorsNum === 0) {
      zeroVendors.push("Public Municipal Utilities")
    }
    if (this.ruralCoopVendorsNum > 0
      && this.ruralCoopRequestedVendorsNum === 0) {
      zeroVendors.push("Rural Electric Cooperatives")
    }

    if (zeroVendors.length == 0) {
      zeroVendorsString = "";
    }
    else if (zeroVendors.length == 1) {
      zeroVendorsString = " " + zeroVendors[0] + " ";
    }
    else if (zeroVendors.length == 2) {
      zeroVendorsString = " " + zeroVendors[0] + " and " + zeroVendors[1] + " ";
    }
    else if (zeroVendors.length == 3) {
      zeroVendorsString = " " + zeroVendors[0] + ",  " + zeroVendors[1] + " and " + zeroVendors[2] + " ";
    }
    return zeroVendorsString;
  }
  get totalVendorStatusString(): string {
    let totalVendors = this.totalNumVendors;
    let totalRequested = this.totalRequestedVendors;
    let totalReceived = this.totalReceivedVendors;
    let totalVendorString = "Issue found.";
    if (totalVendors === null || totalRequested === null || totalReceived === null) {
      totalVendorString = "";
    }
    //IF # of VENDORS RECEIVED MEETS THE MINIMUM (5)
    else if (totalVendors >= 5 && totalReceived >= 5) {
      totalVendorString = "No Issue – You requested and received data from at least 5 electric vendors.";
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # OF VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED = n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived == totalVendors) {
      totalVendorString = "No Issue – You requested and received data from the minimum number of electric vendors.";
    }
    //IF TOTAL # OF VENDORS ≥ 5… AND… # of VENDORS REQUESTED < 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested < 5) {
      totalVendorString = "Issue Found – You did NOT request data from the minimum required number of vendors.";
    }
    //IF TOTAL # of VENDORS ≥ 5 … AND… # of VENDORS REQUESTED ≥ 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested >= 5 && totalReceived < 5) {
      totalVendorString = "Issue Found – You did NOT receive data from the minimum required number of vendors.";
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # of VENDORS REQUESTED < n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested < totalVendors) {
      totalVendorString = "Issue Found – You did NOT request data from the minimum required number of vendors.";
    }
    //IF TOTAL #of VENDORS (n) < 5… AND… # of VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested === totalVendors && totalReceived < totalRequested) {
      totalVendorString = "Issue Found – You did NOT receive data from the minimum required number of vendors.";
    }
    return totalVendorString;
  }
  get totalVendorStatus(): number {
    let totalVendors = this.totalNumVendors;
    let totalRequested = this.totalRequestedVendors;
    let totalReceived = this.totalReceivedVendors;
    let status = -1;
    if (totalVendors === null || totalRequested === null || totalReceived === null) {
      status = -1;
    }
    //IF # of VENDORS RECEIVED MEETS THE MINIMUM (5)
    else if (totalVendors >= 5 && totalReceived >= 5) {
      status = Assessment2aStatusEnum.MeetsMinRequirement5Plus;
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # OF VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED = n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived == totalVendors) {
      status = Assessment2aStatusEnum.MeetsMinRequirementUnder5;
    }
    //IF TOTAL # OF VENDORS ≥ 5… AND… # of VENDORS REQUESTED < 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested < 5) {
      status = Assessment2aStatusEnum.RequestedUnderMin5Plus;
    }
    //IF TOTAL # of VENDORS ≥ 5 … AND… # of VENDORS REQUESTED ≥ 5 … AND… # of VENDORS RECEIVED < 5
    else if (totalVendors >= 5 && totalRequested >= 5 && totalReceived < 5) {
      status = Assessment2aStatusEnum.ReceivedUnderMin5Plus;
    }
    //IF TOTAL # of VENDORS (n) < 5… AND… # of VENDORS REQUESTED < n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested < totalVendors) {
      status = Assessment2aStatusEnum.RequestedUnderMinUnder5;
    }
    //IF TOTAL #of VENDORS (n) < 5… AND… # of VENDORS REQUESTED = n… AND… # of VENDORS RECEIVED < n
    else if (totalVendors < 5 && totalRequested == totalVendors && totalReceived < totalRequested) {
      status = Assessment2aStatusEnum.ReceivedUnderMinUnder5;
    }
    return status;
  }
}
export class OverallAssessmentStepInfo {
  sequenceNumber: number;
  currentFuelName: string;
  showAllFuels: boolean;
  showComputedAverageExpenditure: boolean;
  showSedsElectricNonHeatExpenditure: boolean;
  showPercentOfSedsString: boolean;
  showPercentOfSedsStatus: boolean;
  showNumReq: boolean;
  showNumRec: boolean;
  showTotal: boolean;
  showVendorReceivedStatus: boolean;
  showDataReceivedStatus: boolean;
  showVendorAssignedEntry: boolean;
  showVendorAssignedStatus: boolean;
  showMainHeatAndElectric: boolean;
  showMainHeat: boolean;
  showElectricBaseload: boolean;
  showBothAndNumAndPctAndStatus: boolean;
  constructor(
    sequenceNumber: number,
    currentFuelName: string,
    showAllFuels: boolean,
    showComputedAverageExpenditure: boolean,
    showSedsElectricNonHeatExpenditure: boolean,
    showPercentOfSedsString: boolean,
    showPercentOfSedsStatus: boolean,
    showNumReq: boolean,
    showNumRec: boolean,
    showTotal: boolean,
    showVendorReceivedStatus: boolean,
    showDataReceivedStatus: boolean,
    showVendorAssignedEntry: boolean,
    showVendorAssignedStatus: boolean,
    showMainHeatAndElectric: boolean,
    showMainHeat: boolean,
    showElectricBaseload: boolean,
    showBothAndNumAndPctAndStatus: boolean
  ) {
    this.sequenceNumber = sequenceNumber;
    this.currentFuelName = currentFuelName;
    this.showAllFuels = showAllFuels;
    this.showComputedAverageExpenditure = showComputedAverageExpenditure;
    this.showSedsElectricNonHeatExpenditure = showSedsElectricNonHeatExpenditure;
    this.showPercentOfSedsString = showPercentOfSedsString;
    this.showPercentOfSedsStatus = showPercentOfSedsStatus;
    this.showNumReq = showNumReq;
    this.showNumRec = showNumRec;
    this.showTotal = showTotal;
    this.showVendorReceivedStatus = showVendorReceivedStatus;
    this.showDataReceivedStatus = showDataReceivedStatus;
    this.showVendorAssignedEntry = showVendorAssignedEntry;
    this.showVendorAssignedStatus = showVendorAssignedStatus;
    this.showMainHeatAndElectric = showMainHeatAndElectric;
    this.showMainHeat = showMainHeat;
    this.showElectricBaseload = showElectricBaseload;
    this.showBothAndNumAndPctAndStatus = showBothAndNumAndPctAndStatus;
  }
}
/**
 * This function must be called once and only once from BaseLayout.
 */
export function createState(inParentComponent) {
  return {
    //----------------------------------------------------------------------------------------------
    //General variables
    //----------------------------------------------------------------------------------------------
    ErrorMessage: '',
    CreateAssessmentErrorMessage: '',
    ShowSpinner: false,
    UserInfo: {
      granteeId: -1,
      viewAll: false,
      loggedIn: false
    },
    //ScrollToTop:false,
    MainHeader: 'Overview',
    SEDS_DATA_OK: 'VLOK',
    SEDS_PM_DATA_BAD: 'NLBD',
    SEDS_PM_DATA_ZERO_REP: 'NLB2',
    SEDS_NOT_SERVED: 'NLOK',
    SEDS_INVALID_PM: 'INVP',
    Grantees: [],
    FiscalYears: [],
    FieldsToUpdate: [],
    SedsValueCodesAssociativeArray: [],
    SelectedYear: null,
    SelectedGranteeId: null,
    SelectedGranteeName: null,
    savedAssessments: [],
    selectedAssessmentTypeToCreate: null,
    CurrentAssessementStepIndex: null,
    CurrentAppPage: AppPagesEnum.StartPage,
    CurrentEditingAssessmentKey: null,
    HouseholdsAssisted: null,
    //----------------------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 1 variables
     *--------------------------------------------------------------------------------*/
    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment1FuelTypesStatus: new Assessment1FuelTypesStatusHolder(),
    Assessment1ShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment1Steps: [
      new Assessment1StepInfo(Assessment1StepsEnum.EnterDataAverageExpenditures, "", true, true, false, false, false),
      new Assessment1StepInfo(Assessment1StepsEnum.DisplaySeds, "", true, true, true, false, false),
      new Assessment1StepInfo(Assessment1StepsEnum.PercentOfSeds, "", true, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.NaturalGasFollowup, "NaturalGas", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.FuelOilFollowup, "FuelOil", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.PropaneFollowup, "Propane", false, true, true, true, true),
      new Assessment1StepInfo(Assessment1StepsEnum.ActionPlanSummary, "", false, false, false, false, false),
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 1 methods
     *--------------------------------------------------------------------------------*/
    assessment1GetFuelTypesArray: function (): Assessment1FuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment1FuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment1FuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment1FuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment1ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment1StepsEnum.EnterDataAverageExpenditures) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment1ShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;
        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "1"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        let showNextStepDisabled: boolean = this.state.assessment1ShowNextStepDisabled(this.state.Assessment1FuelTypesStatus
          , newAssessmentStepIndex);

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ShowSpinner: false,
          ErrorMessage: '',
          Assessment1ShowNextStepDisabled: showNextStepDisabled,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment1StepsEnum.ActionPlanSummary;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "1"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }

        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment1ViewAnyway: function (inEvent: any, fuelType: Assessment1FuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment1FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating), fuelType);
      newFuelType.viewAnyway = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == 'viewAnywayFlag') {
          newFieldsToUpdate[counter].value = true;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: 'viewAnywayFlag'
          , fuel: fuelType.name
          , value: true
        }
        newFieldsToUpdate.push(newField);
      }


      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment1FuelTypesStatus: newFuelTypes,
        FieldsToUpdate: newFieldsToUpdate,
      });
    }.bind(inParentComponent),
    assessment1ShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      //-------------------------------------------------------------------------
      //set next button enabled or disabled disabled
      //-------------------------------------------------------------------------
      switch (assessmentStepIndex) {
        case Assessment1StepsEnum.EnterDataAverageExpenditures:
        case Assessment1StepsEnum.DisplaySeds:
        case Assessment1StepsEnum.PercentOfSeds:
          if (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.computedAverageExpenditure)) {
            showNextStepDisabled = true;
          }
          break;
        case Assessment1StepsEnum.NaturalGasFollowup:
          if (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.computedAverageExpenditure)) {
            showNextStepDisabled = true;
          }
          break;
        case Assessment1StepsEnum.FuelOilFollowup:
          if (this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.computedAverageExpenditure)) {
            showNextStepDisabled = true;
          }
          break;
        case Assessment1StepsEnum.PropaneFollowup:
          if (this.state.isNullOrEmpty(fuelTypesStatus.Propane.computedAverageExpenditure)) {
            showNextStepDisabled = true;
          }
          break;
      }
      //-------------------------------------------------------------------------
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment1FieldChangeHandler: function (inEvent: any, fuelType: Assessment1FuelTypeInfo): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment1FuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Expenditure") > -1 && inEvent.target.id != 'ZeroAvgExpenditureDataReasonDesc') {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: fuelType.name
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }

      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment1FuelTypesStatus: newFuelTypes,
        Assessment1ShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    assessment1ShowCatchallQuestionUnder: function (fuelType): boolean {
      let showCatchallQuestion: boolean = false;
      if (fuelType.computedAverageExpenditure === 0 && fuelType.totalAssistedhHNum > 0) {
        showCatchallQuestion = false;
      }
      if (fuelType.IncludingEnergyUseChargesFlag === "Y"
        && fuelType.IncludingEnergyDeliveryChargesFlag === "Y"
        && fuelType.IncludeSupplierChargesFlag === "Y"
        && fuelType.IncludingComplete12MonthFlag === "Y"
        && fuelType.IndicatingLessThan12MonthFlag === "Y"
        && fuelType.ReportingAfterDiscountsFlag === "Y") {
        showCatchallQuestion = true;
      }
      else {
        showCatchallQuestion = false;
      }
      return showCatchallQuestion;
    }.bind(inParentComponent),
    assessment1ShowCatchallQuestionOver: function (fuelType): boolean {
      let showCatchallQuestion: boolean = false;
      if (fuelType.computedAverageExpenditure === 0 && fuelType.totalAssistedhHNum > 0) {
        showCatchallQuestion = false;
      }
      if (fuelType.IncludingEnergyOptionalChargesFlag === false
        && fuelType.Including12MonthOnlyFlag === true
        && fuelType.CheckOutliersFlag === true
        && fuelType.IncludeOnlyAmountBilledFlag === true) {
        showCatchallQuestion = true;
      }
      else {
        showCatchallQuestion = false;
      }
      return showCatchallQuestion;
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 2a variables
     *--------------------------------------------------------------------------------*/
    Assessment2aModelInstance: new Assessment2aModel(),
    Assessment2aShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment2aSteps: [
      new Assessment2aStepInfo(Assessment2aStepsEnum.EnterNumVendors, false, false, false, false, false),
      new Assessment2aStepInfo(Assessment2aStepsEnum.EnterVendorsReq, true, false, false, false, false),
      new Assessment2aStepInfo(Assessment2aStepsEnum.EnterVendorsRec, true, true, true, false, false),
      new Assessment2aStepInfo(Assessment2aStepsEnum.Results, true, true, true, true, false),
      new Assessment2aStepInfo(Assessment2aStepsEnum.ZeroVendorForType, true, true, false, false, true),
      new Assessment2aStepInfo(Assessment2aStepsEnum.ActionPlanSummary, false, false, false, false, false),
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 2a methods
     *--------------------------------------------------------------------------------*/
    assessment2aShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment2aStepsEnum.EnterNumVendors) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment1ShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2aShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2aStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = 0;
        if (this.state.CurrentAssessementStepIndex === Assessment2aStepsEnum.Results) {
          if ((this.state.Assessment2aModelInstance.investorOwnedUtilVendorsNum > 0
            && this.state.Assessment2aModelInstance.investorOwnedUtilRequestedVendorsNum === 0)
            || (this.state.Assessment2aModelInstance.publicMuniUtilVendorsNum > 0
              && this.state.Assessment2aModelInstance.publicMuniUtilRequestedVendorsNum === 0)
            || (this.state.Assessment2aModelInstance.ruralCoopVendorsNum > 0
              && this.state.Assessment2aModelInstance.ruralCoopRequestedVendorsNum === 0)
          ) {
            newAssessmentStepIndex = Assessment2aStepsEnum.ZeroVendorForType;
          }
          else {
            newAssessmentStepIndex = Assessment2aStepsEnum.ActionPlanSummary;
          }
        }
        else {
          newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;
        }

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "2a"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        let showNextStepDisabled = this.state.assessment2aShowNextStepDisabled(this.state.Assessment2aModelInstance, newAssessmentStepIndex);

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment2aShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2aFieldChangeHandler: function (inEvent: any, model: Assessment2aModel): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newModel = new Assessment2aModel();
      newModel = Object.assign(newModel, model);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newModel[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newModel[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newModel[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: ""
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }
      const showNextStepDisabled = this.state.assessment2aShowNextStepDisabled(
        newModel
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment2aModelInstance: newModel,
        Assessment2aShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    assessment2aShowNextStepDisabled: function (model: Assessment2aModel, assessmentStepIndex: number): boolean {
      let showNextStepDisabled = false;
      //-------------------------------------------------------------------------
      //set next button enabled or disabled disabled
      //-------------------------------------------------------------------------
      switch (assessmentStepIndex) {
        case Assessment2aStepsEnum.EnterNumVendors: {
          if (this.state.isNullOrEmpty(model.investorOwnedUtilVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopVendorsNum)) {
            showNextStepDisabled = true;
          }
          break;
        }
        case Assessment2aStepsEnum.EnterVendorsReq: {
          if (this.state.isNullOrEmpty(model.investorOwnedUtilVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopVendorsNum)
            || this.state.isNullOrEmpty(model.investorOwnedUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopRequestedVendorsNum)) {
            showNextStepDisabled = true;
          }
          break;
        }
        case Assessment2aStepsEnum.EnterVendorsRec: {
          if (this.state.isNullOrEmpty(model.investorOwnedUtilVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopVendorsNum)
            || this.state.isNullOrEmpty(model.investorOwnedUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.investorOwnedUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopReceivedVendorsNum)) {
            showNextStepDisabled = true;
          }
          break;
        }
        default: {
          if (this.state.isNullOrEmpty(model.investorOwnedUtilVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopVendorsNum)
            || this.state.isNullOrEmpty(model.investorOwnedUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopRequestedVendorsNum)
            || this.state.isNullOrEmpty(model.investorOwnedUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(model.publicMuniUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(model.ruralCoopReceivedVendorsNum)) {
            showNextStepDisabled = true;
          }
          break;
        }
      }
      //-------------------------------------------------------------------------
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment2aViewAnyway: function (inEvent: any, model: Assessment2aModel): void {
      //create copy of passedFuelTypeObject
      let newModel = Object.assign(new Assessment2aModel(), model);
      newModel.viewAnywayFlag = true;

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].field == 'viewAnywayFlag') {
          newFieldsToUpdate[counter].value = true;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: 'viewAnywayFlag'
          , fuel: ""
          , value: true
        }
        newFieldsToUpdate.push(newField);
      }
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment2aModelInstance: newModel,
        FieldsToUpdate: newFieldsToUpdate,
      });
    }.bind(inParentComponent),
    assessment2aShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2aStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment2aStepsEnum.ActionPlanSummary;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "2a"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 2b variables
     *--------------------------------------------------------------------------------*/
    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment2bFuelTypesStatus: new Assessment2bFuelTypesStatusHolder(),
    Assessment2bShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment2bSteps: [
      new Assessment2bStepInfo(Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived
        , ""
        , true
        , false),
      new Assessment2bStepInfo(Assessment2bStepsEnum.ResultsOverview
        , ""    //currentFuelName
        , true  //showAllFuels
        , true),//showDataReceivedStatus
      new Assessment2bStepInfo(Assessment2bStepsEnum.ResultsDetailElectric
        , "Electric"    //currentFuelName
        , false  //showAllFuels
        , true),//showDataReceivedStatus
      new Assessment2bStepInfo(Assessment2bStepsEnum.ResultsDetailNaturalGas
        , "NaturalGas"    //currentFuelName
        , false  //showAllFuels
        , true),//showDataReceivedStatus
      new Assessment2bStepInfo(Assessment2bStepsEnum.ResultsDetailFuelOil
        , "FuelOil"    //currentFuelName
        , false  //showAllFuels
        , true),//showDataReceivedStatus
      new Assessment2bStepInfo(Assessment2bStepsEnum.ResultsDetailPropane
        , "Propane"    //currentFuelName
        , false  //showAllFuels
        , true),//showDataReceivedStatus
      new Assessment2bStepInfo(Assessment2bStepsEnum.ActionPlanSummary
        , ""    //currentFuelName
        , false  //showAllFuels
        , false),//showDataReceivedStatus
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 2b methods
     *--------------------------------------------------------------------------------*/
    assessment2bGetFuelTypesArray: function (): Assessment2bFuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment2bFuelTypesStatus.Electric);
      fuelArray.push(this.state.Assessment2bFuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment2bFuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment2bFuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment2bShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment2bShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2bShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2bStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "2b"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }

        }

        let showNextStepDisabled: boolean = this.state.assessment2bShowNextStepDisabled(this.state.Assessment2bFuelTypesStatus, newAssessmentStepIndex)

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          Assessment2bShowNextStepDisabled: showNextStepDisabled,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2bShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment2bStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment2bStepsEnum.ActionPlanSummary;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "2b"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment2bViewAnyway: function (inEvent: any, fuelType: Assessment2bFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment2bFuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered), fuelType);
      newFuelType.viewAnywayFlag = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2bFuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == 'viewAnywayFlag') {
          newFieldsToUpdate[counter].value = true;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: 'viewAnywayFlag'
          , fuel: fuelType.name
          , value: true
        }
        newFieldsToUpdate.push(newField);
      }


      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment2bFuelTypesStatus: newFuelTypes,
        FieldsToUpdate: newFieldsToUpdate,
      });
    }.bind(inParentComponent),
    assessment2bShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      if (this.state.isNullOrEmpty(fuelTypesStatus.Electric.totalAssistedhHNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.Electric.hHElectricDataReceivedNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElectricDataReceivedNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElectricDataReceivedNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
        || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElectricDataReceivedNum)
      ) {
        showNextStepDisabled = true;
      }
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment2bFieldChangeHandler: function (inEvent: any, fuelType: Assessment2bFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment2bFuelTypeInfo(fuelType.name
        , fuelType.description
        , fuelType.descriptionHeat
        , fuelType.descriptionHeating
        , fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: fuelType.name
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }

      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2bFuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.assessment2bShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment2bFuelTypesStatus: newFuelTypes,
        Assessment2bShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 3a variables
     *--------------------------------------------------------------------------------*/
    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment3aFuelTypesStatus: new Assessment3aFuelTypesStatusHolder(),
    Assessment3aShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment3aSteps: [
      new Assessment3aStepInfo(Assessment3aStepsEnum.EnterDataNumHouseholds
        , ""
        , true
        , false
        , false),
      new Assessment3aStepInfo(Assessment3aStepsEnum.EnterDataNumHouseholdsVendorAssigned
        , ""    //currentFuelName
        , true  //showAllFuels
        , true  //showVendorAssignedEntry
        , false),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.VendorAssignedStatus
        , ""    //currentFuelName
        , true  //showAllFuels
        , true  //showVendorAssignedEntry
        , true),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.VendorAssignedFollowupElectric
        , "Electric"    //currentFuelName
        , false  //showAllFuels
        , true  //showVendorAssignedEntry
        , true),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.VendorAssignedFollowupNaturalGas
        , "NaturalGas"    //currentFuelName
        , false  //showAllFuels
        , true  //showVendorAssignedEntry
        , true),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.VendorAssignedFollowupFuelOil
        , "FuelOil"    //currentFuelName
        , false  //showAllFuels
        , true  //showVendorAssignedEntry
        , true),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.VendorAssignedFollowupPropane
        , "Propane"    //currentFuelName
        , false  //showAllFuels
        , true  //showVendorAssignedEntry
        , true),//showVendorAssignedStatus
      new Assessment3aStepInfo(Assessment3aStepsEnum.ActionPlanSummary
        , ""    //currentFuelName
        , false  //showAllFuels
        , false  //showVendorAssignedEntry
        , false),//showVendorAssignedStatus
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 3a methods
     *--------------------------------------------------------------------------------*/
    assessment3aGetFuelTypesArray: function (): Assessment3aFuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment3aFuelTypesStatus.Electric);
      fuelArray.push(this.state.Assessment3aFuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment3aFuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment3aFuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment3aShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment3aStepsEnum.EnterDataNumHouseholds) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment3aShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3aShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3aStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "3a"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        const showNextStepDisabled = this.state.assessment3aShowNextStepDisabled(this.state.Assessment3aFuelTypesStatus, newAssessmentStepIndex);

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment3aShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3aShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3aStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment3aStepsEnum.ActionPlanSummary;
        if (this.state.FieldsToUpdate.length > 0) {
          //update saved assessment details
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "3a"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3aViewAnyway: function (inEvent: any, fuelType: Assessment3aFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment3aFuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered), fuelType);
      newFuelType.viewAnywayFlag = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3aFuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == 'viewAnywayFlag') {
          newFieldsToUpdate[counter].value = true;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: 'viewAnywayFlag'
          , fuel: fuelType.name
          , value: true
        }
        newFieldsToUpdate.push(newField);
      }
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3aFuelTypesStatus: newFuelTypes,
        FieldsToUpdate: newFieldsToUpdate,
      });
    }.bind(inParentComponent),
    assessment3aShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      if (assessmentStepIndex === Assessment3aStepsEnum.EnterDataNumHouseholds &&
        (this.state.isNullOrEmpty(fuelTypesStatus.Electric.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum))) {
        showNextStepDisabled = true;
      }
      else if (assessmentStepIndex !== Assessment3aStepsEnum.EnterDataNumHouseholds &&
        (this.state.isNullOrEmpty(fuelTypesStatus.Electric.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Electric.hHAssignedVendorNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHAssignedVendorNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHAssignedVendorNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHAssignedVendorNum))
      ) {
        showNextStepDisabled = true;
      }
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment3aFieldChangeHandler: function (inEvent: any, fuelType: Assessment3aFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment3aFuelTypeInfo(fuelType.name
        , fuelType.description
        , fuelType.descriptionHeat
        , fuelType.descriptionHeating
        , fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: fuelType.name
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }

      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3aFuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.assessment3aShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3aFuelTypesStatus: newFuelTypes,
        Assessment3aShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 3b variables
     *--------------------------------------------------------------------------------*/
    //create an object to hold current status of all steps/table cells for all fuel types
    Assessment3bFuelTypesStatus: new Assessment3bFuelTypesStatusHolder(),
    Assessment3bShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment3bSteps: [
      //EnterDataNumHouseholds
      new Assessment3bStepInfo(Assessment3bStepsEnum.EnterDataNumHouseholds//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      //NumHouseholdsBothHeatAndElectric
      new Assessment3bStepInfo(Assessment3bStepsEnum.NumHouseholdsBothHeatAndElectric//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      //NumHouseholds12MoMainHeatData
      new Assessment3bStepInfo(Assessment3bStepsEnum.NumHouseholdsMainHeatData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showMainHeatAndElectric
        , true//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      //NumHouseholds12MoElectricData
      new Assessment3bStepInfo(Assessment3bStepsEnum.NumHouseholdsElectricData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showMainHeatAndElectric
        , true//showMainHeat
        , true//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      //ResultsOverview
      new Assessment3bStepInfo(Assessment3bStepsEnum.ResultsOverview//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      ),
      //AccountMatchingNaturalGas
      new Assessment3bStepInfo(Assessment3bStepsEnum.AccountMatchingNaturalGas//sequenceNumber
        , "NaturalGas"//currentFuelName
        , false//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      ),
      //AccountMatchingFuelOil
      new Assessment3bStepInfo(Assessment3bStepsEnum.AccountMatchingFuelOil//sequenceNumber
        , "FuelOil"//currentFuelName
        , false//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      ),
      //AccountMatchingPropane
      new Assessment3bStepInfo(Assessment3bStepsEnum.AccountMatchingPropane//sequenceNumber
        , "Propane"//currentFuelName
        , false//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      ),
      //ActionPlanSummary
      new Assessment3bStepInfo(Assessment3bStepsEnum.AccountMatchingPropane//sequenceNumber
        , ""//currentFuelName
        , false//showAllFuels
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 3b methods
     *--------------------------------------------------------------------------------*/
    assessment3bGetFuelTypesArray: function (): Assessment3bFuelTypeInfo[] {
      let fuelArray = [];
      fuelArray.push(this.state.Assessment3bFuelTypesStatus.NaturalGas);
      fuelArray.push(this.state.Assessment3bFuelTypesStatus.FuelOil);
      fuelArray.push(this.state.Assessment3bFuelTypesStatus.Propane);
      return fuelArray
    }.bind(inParentComponent),
    assessment3bShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment3bStepsEnum.EnterDataNumHouseholds) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;

        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment3bShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3bShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3bStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "3b"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        const showNextStepDisabled = this.state.assessment3bShowNextStepDisabled(this.state.Assessment3bFuelTypesStatus, newAssessmentStepIndex);

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment3bShowNextStepDisabled: showNextStepDisabled,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3bShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment3bStepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment3bStepsEnum.ActionPlanSummary;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "3b"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment3bViewAnyway: function (inEvent: any, fuelType: Assessment3bFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = Object.assign(new Assessment3bFuelTypeInfo(fuelType.name, fuelType.description, fuelType.descriptionHeat, fuelType.descriptionHeating, fuelType.targetPercentHouseholdsCovered), fuelType);
      newFuelType.viewAnywayFlag = true;

      //create a copy of the fuel types object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3bFuelTypesStatus);
      newFuelTypes[fuelType.name] = newFuelType;

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == 'viewAnywayFlag') {
          newFieldsToUpdate[counter].value = true;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: 'viewAnywayFlag'
          , fuel: fuelType.name
          , value: true
        }
        newFieldsToUpdate.push(newField);
      }
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3bFuelTypesStatus: newFuelTypes,
        FieldsToUpdate: newFieldsToUpdate,
      });
    }.bind(inParentComponent),
    assessment3bShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      if (assessmentStepIndex === Assessment3bStepsEnum.EnterDataNumHouseholds &&
        (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum))) {
        showNextStepDisabled = true;
      }
      else if (assessmentStepIndex === Assessment3bStepsEnum.NumHouseholdsBothHeatAndElectric
        &&
        (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticAndMainHeatDataNum))) {
        showNextStepDisabled = true;
      }
      else if (assessmentStepIndex === Assessment3bStepsEnum.NumHouseholdsMainHeatData
        &&
        (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticAndMainHeatDataNum))) {
        showNextStepDisabled = true;
      }
      else if ((assessmentStepIndex > Assessment3bStepsEnum.NumHouseholdsMainHeatData)
        &&
        (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticAndMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHMainHeatDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticDataNum)
          || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticAndMainHeatDataNum))) {
        showNextStepDisabled = true;
      }
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment3bFieldChangeHandler: function (inEvent: any, fuelType: Assessment3bFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = new Assessment3bFuelTypeInfo(fuelType.name
        , fuelType.description
        , fuelType.descriptionHeat
        , fuelType.descriptionHeating
        , fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }
      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: fuelType.name
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }
      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3bFuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.assessment3bShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment3bFuelTypesStatus: newFuelTypes,
        Assessment3bShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize assessment 4 variables
     *--------------------------------------------------------------------------------*/
    Assessment4ModelInstance: new Assessment4Model(),
    Assessment4ShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    Assessment4Steps: [
      new Assessment4StepInfo(Assessment4StepsEnum.Q1TrackAcctNoFormat),
      new Assessment4StepInfo(Assessment4StepsEnum.Q2TrackPercentAccountNo),
      new Assessment4StepInfo(Assessment4StepsEnum.Q3TractPercentVendorNotFind),
      new Assessment4StepInfo(Assessment4StepsEnum.Q4IdLargestVendors),
      new Assessment4StepInfo(Assessment4StepsEnum.Q5TrackVendorCompliance),
      new Assessment4StepInfo(Assessment4StepsEnum.Q6ExcludeNot12MoData),
      new Assessment4StepInfo(Assessment4StepsEnum.Q7CheckOutliers),
      new Assessment4StepInfo(Assessment4StepsEnum.Q8ProcessReviewFindings),
      new Assessment4StepInfo(Assessment4StepsEnum.Q9AddingChecks),
      new Assessment4StepInfo(Assessment4StepsEnum.Q10RemovingChecks),
      new Assessment4StepInfo(Assessment4StepsEnum.ActionPlanSummary),
    ],
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Assessment 4 methods
     *--------------------------------------------------------------------------------*/
    assessment4ShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > Assessment4StepsEnum.Q1TrackAcctNoFormat) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          Assessment4ShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4ShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "4"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }


        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4ShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;
      //if(fuelTypesStatus.Electric.totalAssistedhHNum === null
      //  || fuelTypesStatus.Electric.hHElectricDataReceivedNum === null
      //  || fuelTypesStatus.NaturalGas.computedAverageExpenditure === null
      //  || fuelTypesStatus.NaturalGas.hHElectricDataReceivedNum === null
      //  || fuelTypesStatus.FuelOil.computedAverageExpenditure === null
      //  || fuelTypesStatus.FuelOil.hHElectricDataReceivedNum === null
      //  || fuelTypesStatus.Propane.computedAverageExpenditure === null
      //  || fuelTypesStatus.Propane.hHElectricDataReceivedNum === null
      //  ){
      //  showNextStepDisabled = true;
      //}
      return showNextStepDisabled;
    }.bind(inParentComponent),
    assessment4ShowActionPlan: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < Assessment4StepsEnum.ActionPlanSummary) {
        let newAssessmentStepIndex = Assessment4StepsEnum.ActionPlanSummary;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "4"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }
        //set state object
        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    assessment4FieldChangeHandler: function (inEvent: any, model: Assessment4Model): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newModel = new Assessment4Model();
      newModel = Object.assign(newModel, model);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newModel[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newModel[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newModel[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: ""
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }
      const showNextStepDisabled = this.state.assessment4ShowNextStepDisabled(
        newModel
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        Assessment4ModelInstance: newModel,
        Assessment4ShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Initialize OverallAssessment variables
     *--------------------------------------------------------------------------------*/
    OverallAssessmentFuelTypesStatus: new OverallAssessmentFuelTypesStatusHolder(),
    OverallAssessmentShowNextStepDisabled: true,
    //create an array of all of the steps in this assessment
    OverallAssessmentSteps: [
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment1EnterData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showComputedAverageExpenditure
        , true//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment1Results//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showComputedAverageExpenditure
        , true//showSedsElectricNonHeatExpenditure
        , true//showPercentOfSedsString
        , true//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment2AEnterData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , true//showNumReq
        , true//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment2AResults//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , true//showNumReq
        , true//showNumRec
        , true//showTotal
        , true//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment2BEnterData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment2BResults//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , true//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment3AEnterData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , true//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment3AResults//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , true//showVendorAssignedEntry
        , true//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment3BEnterData//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , true//showMainHeatAndElectric
        , true//showMainHeat
        , true//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment3BResults//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , true//showMainHeatAndElectric
        , true//showMainHeat
        , true//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment4EnterData//sequenceNumber
        , ""//currentFuelName
        , false//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.Assessment4Results//sequenceNumber
        , ""//currentFuelName
        , false//showAllFuels
        , false//showComputedAverageExpenditure
        , false//showSedsElectricNonHeatExpenditure
        , false//showPercentOfSedsString
        , false//showPercentOfSedsStatus
        , false//showNumReq
        , false//showNumRec
        , false//showTotal
        , false//showVendorReceivedStatus
        , false//showDataReceivedStatus
        , false//showVendorAssignedEntry
        , false//showVendorAssignedStatus
        , false//showMainHeatAndElectric
        , false//showMainHeat
        , false//showElectricBaseload
        , false//showBothAndNumAndPctAndStatus
      ),
      new OverallAssessmentStepInfo(OverallAssessmentStepsEnum.ResultsOverview//sequenceNumber
        , ""//currentFuelName
        , true//showAllFuels
        , true//showComputedAverageExpenditure
        , true//showSedsElectricNonHeatExpenditure
        , true//showPercentOfSedsString
        , true//showPercentOfSedsStatus
        , true//showNumReq
        , true//showNumRec
        , true//showTotal
        , true//showVendorReceivedStatus
        , true//showDataReceivedStatus
        , true//showVendorAssignedEntry
        , true//showVendorAssignedStatus
        , true//showMainHeatAndElectric
        , true//showMainHeat
        , true//showElectricBaseload
        , true//showBothAndNumAndPctAndStatus
      )
    ],
    //--------------------------------------------------------------------------------


    /*--------------------------------------------------------------------------------
     * Overall assessment methods
     *--------------------------------------------------------------------------------*/
    overallAssessmentShowPreviousStep: function (): void {
      if (this.state.CurrentAssessementStepIndex > OverallAssessmentStepsEnum.Assessment1EnterData) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex - 1;
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAssessementStepIndex: newAssessmentStepIndex,
          OverallAssessmentShowNextStepDisabled: false,
        });
        this.state.scrollToTop();
      }
      else {
        //set state object
        this.setState({
          ErrorMessage: '',
          CurrentAppPage: AppPagesEnum.SelectStateAndYear,
          MainHeader: 'Select State and Year',
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    overallAssessmentShowNextStep: async function (): Promise<void> {
      if (this.state.CurrentAssessementStepIndex < OverallAssessmentStepsEnum.ResultsOverview) {
        let newAssessmentStepIndex = this.state.CurrentAssessementStepIndex + 1;

        //update saved assessment details
        if (this.state.FieldsToUpdate.length > 0) {
          const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
          try {
            const result = await assessmentWorker.updateAssessmentDetails(this.state.CurrentEditingAssessmentKey
              , "oa"
              , this.state.FieldsToUpdate
            );
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }
        }

        let showNextStepDisabled = this.state.overallAssessmentShowNextStepDisabled(this.state.OverallAssessmentFuelTypesStatus, newAssessmentStepIndex);

        //set state object
        this.setState({
          FieldsToUpdate: [],
          ErrorMessage: '',
          ShowSpinner: false,
          OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
          CurrentAssessementStepIndex: newAssessmentStepIndex,
        });
        document.getElementById("app").scrollIntoView()
      }
    }.bind(inParentComponent),
    //for changes to the holder
    overallAssessmentFieldChangeHandlerHolder: function (inEvent: any, fuelTypeHolder: OverallAssessmentFuelTypesStatusHolder): void {
      //create a copy of the fuel type
      //create copy of passedFuelTypeObject
      let newHolder = new OverallAssessmentFuelTypesStatusHolder();
      newHolder = Object.assign(newHolder, fuelTypeHolder);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newHolder[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newHolder[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newHolder[inEvent.target.id] = inEvent.target.value;
      }

      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: ""
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }
      const showNextStepDisabled = this.state.overallAssessmentShowNextStepDisabled(
        newHolder
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        OverallAssessmentFuelTypesStatus: newHolder,
        OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    //for changes to fuel type
    overallAssessmentFieldChangeHandler: function (inEvent: any, fuelType: OverallAssessmentFuelTypeInfo): void {
      //create copy of passedFuelTypeObject
      let newFuelType = new OverallAssessmentFuelTypeInfo(fuelType.name
        , fuelType.description
        , fuelType.descriptionHeat
        , fuelType.descriptionHeating
        , fuelType.targetPercentHouseholdsCovered);
      newFuelType = Object.assign(newFuelType, fuelType);
      //update the appropriate field
      if (inEvent.target.name.indexOf("Flag") > -1) {
        newFuelType[inEvent.target.name] = inEvent.target.value;
      }
      else if (inEvent.target && inEvent.target.id.indexOf("Num") > -1) {
        newFuelType[inEvent.target.id] = this.state.nullOrNumberToNumber(inEvent.target.value);
      }
      else {
        newFuelType[inEvent.target.id] = inEvent.target.value;
      }
      //create copy of fields to update
      let newFieldsToUpdate: utility.IFieldToUpdate[];
      newFieldsToUpdate = Array.from(this.state.FieldsToUpdate);
      let fieldExists = false;
      for (var counter = 0; counter < this.state.FieldsToUpdate.length; counter++) {
        if (newFieldsToUpdate[counter].fuel == fuelType.name
          && newFieldsToUpdate[counter].field == inEvent.target.name) {
          newFieldsToUpdate[counter].value = inEvent.target.value;
          fieldExists = true;
        }
      }
      if (!fieldExists) {
        let newField: utility.IFieldToUpdate = {
          field: inEvent.target.name
          , fuel: fuelType.name
          , value: inEvent.target.value
        }
        newFieldsToUpdate.push(newField);
      }
      //create a copy of the holder object
      let newFuelTypes = {};
      newFuelTypes = Object.assign(newFuelTypes, this.state.OverallAssessmentFuelTypesStatus);
      //replace fuel type in holder object with new fuel type
      newFuelTypes[fuelType.name] = newFuelType;
      const showNextStepDisabled = this.state.overallAssessmentShowNextStepDisabled(
        newFuelTypes
        , this.state.CurrentAssessementStepIndex);
      //set state object
      this.setState({
        ErrorMessage: '',
        OverallAssessmentFuelTypesStatus: newFuelTypes,
        OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
        FieldsToUpdate: newFieldsToUpdate,
      });
      //set state
    }.bind(inParentComponent),
    overallAssessmentShowNextStepDisabled: function (fuelTypesStatus, assessmentStepIndex): boolean {
      let showNextStepDisabled = false;

      switch (assessmentStepIndex) {
        case (OverallAssessmentStepsEnum.Assessment1EnterData):
        case (OverallAssessmentStepsEnum.Assessment1Results):
          if (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.computedAverageExpenditure)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.computedAverageExpenditure)) {
            showNextStepDisabled = true;
          }
          break;
        case (OverallAssessmentStepsEnum.Assessment2AEnterData):
        case (OverallAssessmentStepsEnum.Assessment2AResults):
          if (this.state.isNullOrEmpty(fuelTypesStatus.investorOwnedUtilVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.investorOwnedUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.investorOwnedUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.publicMuniUtilVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.publicMuniUtilRequestedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.publicMuniUtilReceivedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.ruralCoopVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.ruralCoopRequestedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.ruralCoopReceivedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.unknownTypeVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.unknownTypeRequestedVendorsNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.unknownTypeReceivedVendorsNum)) {
            showNextStepDisabled = true;
          }
          break;
        case (OverallAssessmentStepsEnum.Assessment2BEnterData):
        case (OverallAssessmentStepsEnum.Assessment2BResults):
          if (this.state.isNullOrEmpty(fuelTypesStatus.Electric.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Electric.hHElectricDataReceivedNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElectricDataReceivedNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElectricDataReceivedNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElectricDataReceivedNum)) {
            showNextStepDisabled = true;
          }
          break;
        case (OverallAssessmentStepsEnum.Assessment3AEnterData):
        case (OverallAssessmentStepsEnum.Assessment3AResults):
          if (this.state.isNullOrEmpty(fuelTypesStatus.Electric.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Electric.hHAssignedVendorNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHAssignedVendorNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHAssignedVendorNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHAssignedVendorNum)) {
            showNextStepDisabled = true;
          }
          break;
        case (OverallAssessmentStepsEnum.Assessment3BEnterData):
        case (OverallAssessmentStepsEnum.Assessment3BResults):
          if (this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticAndMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.NaturalGas.hHElecticDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticAndMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.Propane.hHElecticDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.totalAssistedhHNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticAndMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHMainHeatDataNum)
            || this.state.isNullOrEmpty(fuelTypesStatus.FuelOil.hHElecticDataNum)) {
            showNextStepDisabled = true;
          }
          break;
      }
      return showNextStepDisabled;
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------        

    /*--------------------------------------------------------------------------------
     * All assessment methods
     *--------------------------------------------------------------------------------*/
    assessmentLoadSavedAssessment: async function (inAssessmentId: number, inAssessmentType: string): Promise<void> {
      this.state.showSpinner();

      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      let grantees: worker.IGrantee[] = [];
      try {
        grantees = await baseWorker.getGrantees();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];

      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      let fiscalYears: worker.IFiscalYear[] = [];
      try {
        fiscalYears = await baseWorker.getSedsYears();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }
      this.setState({
        ErrorMessage: '',
        Grantees: grantees,
        FiscalYears: fiscalYears,
        selectedAssessmentTypeToCreate: inAssessmentType,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      if (inAssessmentType.toString() === "1") {//note that assessment type being passed as a string

        let holder: Assessment1FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment1Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(holder, Assessment1StepsEnum.EnterDataAverageExpenditures);
        this.setState({
          ErrorMessage: '',
          Assessment1ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment1,
          CurrentAssessementStepIndex: Assessment1StepsEnum.EnterDataAverageExpenditures,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment1FuelTypesStatus: holder,
          MainHeader: "Assessment 1: Defining Data Requirements",
        });
      }
      else if (inAssessmentType.toString() === "2a") {//note that assessment type being passed as a string
        let model: Assessment2aModel = null;
        try {
          model = await assessmentWorker.getAssessment2aDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment2aShowNextStepDisabled(model, Assessment2aStepsEnum.EnterNumVendors);
        this.setState({
          ErrorMessage: '',
          Assessment2aShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2a,
          CurrentAssessementStepIndex: Assessment2aStepsEnum.EnterNumVendors,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          Assessment2aModelInstance: model,
          MainHeader: "Assessment 2a: Data Collection - Vendors",
        });
      }
      else if (inAssessmentType.toString() === "2b") {//note that assessment type being passed as a string
        let holder: Assessment2bFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment2bDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        const showNextStepDisabled = this.state.assessment2bShowNextStepDisabled(holder, Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived);
        this.setState({
          ErrorMessage: '',
          Assessment2bShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2b,
          CurrentAssessementStepIndex: Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment2bFuelTypesStatus: holder,
          MainHeader: "Assessment 2B: Data Collection – Households",
        });
      }
      else if (inAssessmentType.toString() === "3a") {//note that assessment type being passed as a string
        let holder: Assessment3aFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3aDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
          fiscalYear: holder.FiscalYear,
          granteeId: holder.Grantee,
          numberOfAssistedHouseholdsAll: null,
          numberOfAssistedHouseholdsElectric: holder.Electric.totalAssistedhHNum,
          numberOfAssistedHouseholdsNaturalGas: holder.NaturalGas.totalAssistedhHNum,
          numberOfAssistedHouseholdsFuelOil: holder.FuelOil.totalAssistedhHNum,
          numberOfAssistedHouseholdsPropane: holder.Propane.totalAssistedhHNum,
          numberOfAssistedHouseholdsOther: null,
          householdsBillingDataElectric: null,
          householdsBillingDataNaturalGas: null,
          householdsBillingDataFuelOil: null,
          householdsBillingDataPropane: null,

        };

        const showNextStepDisabled = this.state.assessment3aShowNextStepDisabled(holder, Assessment3aStepsEnum.EnterDataNumHouseholds);
        this.setState({
          ErrorMessage: '',
          Assessment3aShowNextStepDisabled: showNextStepDisabled,
          HouseholdsAssisted: numHouseholdsAssisted,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3a,
          CurrentAssessementStepIndex: Assessment3aStepsEnum.EnterDataNumHouseholds,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3aFuelTypesStatus: holder,
          MainHeader: "Assessment 3A: Data Recording & Processing – Vendor Assignment",
        });
      }
      else if (inAssessmentType.toString() === "3b") {//note that assessment type being passed as a string
        let holder: Assessment3bFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3bDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
          fiscalYear: holder.FiscalYear,
          granteeId: holder.Grantee,
          numberOfAssistedHouseholdsAll: null,
          numberOfAssistedHouseholdsElectric: null,
          numberOfAssistedHouseholdsNaturalGas: holder.NaturalGas.totalAssistedhHNum,
          numberOfAssistedHouseholdsFuelOil: holder.FuelOil.totalAssistedhHNum,
          numberOfAssistedHouseholdsPropane: holder.Propane.totalAssistedhHNum,
          numberOfAssistedHouseholdsOther: null,
          householdsBillingDataNaturalGas: holder.NaturalGas.hHElecticAndMainHeatDataNum,
          householdsBillingDataFuelOil: holder.FuelOil.hHElecticAndMainHeatDataNum,
          householdsBillingDataPropane: holder.Propane.hHElecticAndMainHeatDataNum,
          householdsBillingDataElectric: null,
        };

        const showNextStepDisabled = this.state.assessment3bShowNextStepDisabled(holder, Assessment3bStepsEnum.EnterDataNumHouseholds);
        this.setState({
          ErrorMessage: '',
          Assessment3bShowNextStepDisabled: showNextStepDisabled,
          HouseholdsAssisted: numHouseholdsAssisted,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3b,
          CurrentAssessementStepIndex: Assessment3bStepsEnum.EnterDataNumHouseholds,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3bFuelTypesStatus: holder,
          MainHeader: "Assessment 3B: Data Recording & Processing – Account Matching",
        });
      }
      else if (inAssessmentType.toString() === "4") {//note that assessment type being passed as a string
        let model: Assessment4Model = null;
        try {
          model = await assessmentWorker.getAssessment4Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        this.setState({
          ErrorMessage: '',
          Assessment4ModelInstance: model,
          Assessment4ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment4,
          CurrentAssessementStepIndex: Assessment4StepsEnum.Q1TrackAcctNoFormat,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          MainHeader: "Assessment 4: Data Checking Routines",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "oa") {//note that assessment type being passed as a string
        let holder: OverallAssessmentFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getOverallAssessmentDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        const showNextStepDisabled = this.state.overallAssessmentShowNextStepDisabled(holder, OverallAssessmentStepsEnum.Assessment1EnterData);
        this.setState({
          ErrorMessage: '',
          OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.OverallAssessment,
          CurrentAssessementStepIndex: OverallAssessmentStepsEnum.Assessment1EnterData,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          OverallAssessmentFuelTypesStatus: holder,
          MainHeader: "Overall Reliability Assessment",
        });
      }
      document.getElementById("app").scrollIntoView()
      this.state.hideSpinner();
    }.bind(inParentComponent),
    assessmentLoadActionPlan: async function (inAssessmentId: number, inAssessmentType: string): Promise<void> {
      this.state.showSpinner();
      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      let grantees: worker.IGrantee[] = [];
      try {
        grantees = await baseWorker.getGrantees();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];
      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      let fiscalYears: worker.IFiscalYear[] = [];
      try {
        fiscalYears = await baseWorker.getSedsYears();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }
      this.setState({
        ErrorMessage: '',
        Grantees: grantees,
        FiscalYears: fiscalYears,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });

      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      if (inAssessmentType.toString() === "1") {//note that assessment type being passed as a string

        let holder: Assessment1FuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment1Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(holder, Assessment1StepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment1ShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment1,
          CurrentAssessementStepIndex: Assessment1StepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment1FuelTypesStatus: holder,
          MainHeader: "Assessment 1: Defining Data Requirements",
        });
      }
      else if (inAssessmentType.toString() === "2a") {//note that assessment type being passed as a string
        let model: Assessment2aModel = null;
        try {
          model = await assessmentWorker.getAssessment2aDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }

        const showNextStepDisabled = this.state.assessment2aShowNextStepDisabled(model, Assessment2aStepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment2aShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2a,
          CurrentAssessementStepIndex: Assessment2aStepsEnum.ActionPlanSummary,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          Assessment2aModelInstance: model,
          MainHeader: "Assessment 2a : Data Collection - Vendors",
        });
      }
      if (inAssessmentType.toString() === "2b") {//note that assessment type being passed as a string
        let holder: Assessment2bFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment2bDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        const showNextStepDisabled = this.state.assessment2bShowNextStepDisabled(holder, Assessment2bStepsEnum.ActionPlanSummary);
        this.setState({
          ErrorMessage: '',
          Assessment2bShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment2b,
          CurrentAssessementStepIndex: Assessment2bStepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment2bFuelTypesStatus: holder,
          MainHeader: "Assessment 2B: Data Collection – Households",
        });
      }
      else if (inAssessmentType.toString() === "3a") {//note that assessment type being passed as a string
        let holder: Assessment3aFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3aDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
          fiscalYear: holder.FiscalYear,
          granteeId: holder.Grantee,
          numberOfAssistedHouseholdsAll: null,
          numberOfAssistedHouseholdsElectric: holder.Electric.totalAssistedhHNum,
          numberOfAssistedHouseholdsNaturalGas: holder.NaturalGas.totalAssistedhHNum,
          numberOfAssistedHouseholdsFuelOil: holder.FuelOil.totalAssistedhHNum,
          numberOfAssistedHouseholdsPropane: holder.Propane.totalAssistedhHNum,
          numberOfAssistedHouseholdsOther: null,
          householdsBillingDataNaturalGas: null,
          householdsBillingDataFuelOil: null,
          householdsBillingDataPropane: null,
          householdsBillingDataElectric: null,
        };

        const showNextStepDisabled = this.state.assessment3aShowNextStepDisabled(holder, Assessment3aStepsEnum.EnterDataNumHouseholds);
        this.setState({
          ErrorMessage: '',
          Assessment3aShowNextStepDisabled: showNextStepDisabled,
          HouseholdsAssisted: numHouseholdsAssisted,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3a,
          CurrentAssessementStepIndex: Assessment3aStepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3aFuelTypesStatus: holder,
          MainHeader: "Assessment 3A: Data Recording & Processing – Vendor Assignment",
        });
      }
      else if (inAssessmentType.toString() === "3b") {//note that assessment type being passed as a string
        let holder: Assessment3bFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getAssessment3bDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
          fiscalYear: holder.FiscalYear,
          granteeId: holder.Grantee,
          numberOfAssistedHouseholdsAll: null,
          numberOfAssistedHouseholdsElectric: null,
          numberOfAssistedHouseholdsNaturalGas: holder.NaturalGas.totalAssistedhHNum,
          numberOfAssistedHouseholdsFuelOil: holder.FuelOil.totalAssistedhHNum,
          numberOfAssistedHouseholdsPropane: holder.Propane.totalAssistedhHNum,
          numberOfAssistedHouseholdsOther: null,
          householdsBillingDataNaturalGas: holder.NaturalGas.hHElecticAndMainHeatDataNum,
          householdsBillingDataFuelOil: holder.FuelOil.hHElecticAndMainHeatDataNum,
          householdsBillingDataPropane: holder.Propane.hHElecticAndMainHeatDataNum,
          householdsBillingDataElectric: null,
        };

        const showNextStepDisabled = this.state.assessment3bShowNextStepDisabled(holder, Assessment3bStepsEnum.EnterDataNumHouseholds);
        this.setState({
          ErrorMessage: '',
          Assessment3bShowNextStepDisabled: showNextStepDisabled,
          HouseholdsAssisted: numHouseholdsAssisted,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment3b,
          CurrentAssessementStepIndex: Assessment3bStepsEnum.ActionPlanSummary,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          Assessment3bFuelTypesStatus: holder,
          MainHeader: "Assessment 3B: Data Recording & Processing – Account Matching",
        });
      }
      else if (inAssessmentType.toString() === "4") {//note that assessment type being passed as a string
        let model: Assessment4Model = null;
        try {
          model = await assessmentWorker.getAssessment4Details(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        this.setState({
          ErrorMessage: '',
          Assessment4ModelInstance: model,
          Assessment4ShowNextStepDisabled: false,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.Assessment4,
          CurrentAssessementStepIndex: Assessment4StepsEnum.ActionPlanSummary,
          SelectedYear: model.FiscalYear,
          SelectedGranteeId: model.Grantee,
          SelectedGranteeName: this.state.getGranteeName(model.Grantee),
          MainHeader: "Assessment 4: Data Checking Routines",
        });
        document.getElementById("app").scrollIntoView()
      }
      else if (inAssessmentType.toString() === "oa") {//note that assessment type being passed as a string
        let holder: OverallAssessmentFuelTypesStatusHolder = null;
        try {
          holder = await assessmentWorker.getOverallAssessmentDetails(inAssessmentId);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        const showNextStepDisabled = this.state.overallAssessmentShowNextStepDisabled(holder, OverallAssessmentStepsEnum.Assessment1EnterData);
        this.setState({
          ErrorMessage: '',
          OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
          CurrentEditingAssessmentKey: inAssessmentId,
          CurrentAppPage: AppPagesEnum.OverallAssessment,
          CurrentAssessementStepIndex: OverallAssessmentStepsEnum.ResultsOverview,
          SelectedYear: holder.FiscalYear,
          SelectedGranteeId: holder.Grantee,
          SelectedGranteeName: this.state.getGranteeName(holder.Grantee),
          OverallAssessmentFuelTypesStatus: holder,
          MainHeader: "Overall Reliability Assessment",
        });
      }
      document.getElementById("app").scrollIntoView()
      this.state.hideSpinner();
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Select State And Year methods
     *--------------------------------------------------------------------------------*/
    SelectStateAndYearShowPreviousStep: function (): void {
      this.setState({
        ErrorMessage: '',
        CurrentAppPage: AppPagesEnum.StartNewAssessment,
        SelectedYear: null,
        SelectedGranteeId: null,
        SelectedGranteeName: null,
        selectedAssessmentTypeToCreate: null,
        CurrentEditingAssessmentKey: null,
        Assessment1FuelTypesStatus: new Assessment1FuelTypesStatusHolder(),
        Assessment2bFuelTypesStatus: new Assessment2bFuelTypesStatusHolder(),
        Assessment3aFuelTypesStatus: new Assessment3aFuelTypesStatusHolder(),
        Assessment3bFuelTypesStatus: new Assessment3bFuelTypesStatusHolder(),
        OverallAssessmentFuelTypesStatus: new OverallAssessmentFuelTypesStatusHolder(),
      });
      document.getElementById("app").scrollIntoView()
    }.bind(inParentComponent),
    SelectStateAndYearShowNextStep: async function (): Promise<void> {
      this.state.showSpinner();
      document.getElementById("app").scrollIntoView()
      let pageToGoTo: number = 0;
      let headerText = 'Overview';

      //IF WE'RE GOING TO AN EXISTING ASSESSMENT.  
      if (this.state.CurrentEditingAssessmentKey != null && this.state.CurrentEditingAssessmentKey != "") {
        switch (this.state.nullOrNumberToNumber(this.state.selectedAssessmentTypeToCreate)) {
          case "1":
            pageToGoTo = AppPagesEnum.Assessment1;
            headerText = "Assessment 1: Defining Data Requirements";
            break;
          case "2a":
            pageToGoTo = AppPagesEnum.Assessment2a;
            headerText = "Assessment 2A: Data Collection - Vendors";
            break;
          case "2b":
            pageToGoTo = AppPagesEnum.Assessment2b;
            headerText = "Assessment 2B: Data Collection - Households";
            break;
          case "3a":
            pageToGoTo = AppPagesEnum.Assessment3a;
            headerText = "Assessment 3A: Data Recording &  Processing – Vendor Assignment";
            break;
          case "3b":
            pageToGoTo = AppPagesEnum.Assessment3a;
            headerText = "Assessment 3B: Data Recording & Processing – Account Matching";
            break;
          case "4":
            pageToGoTo = AppPagesEnum.Assessment4;
            headerText = "Assessment 4: Data Checking Routines";
            break;
          case "oa":
            pageToGoTo = AppPagesEnum.OverallAssessment;
            headerText = "Overall Reliability Assessment";
            break;
        }

        this.setState({
          ErrorMessage: '',
          ShowSpinner: false,
          CurrentAppPage: pageToGoTo,
          MainHeader: headerText,
        });

        document.getElementById("app").scrollIntoView()
        return;
      }
      else// create a new assessment
      {
        //for assessment 1 and 5, check if pm data exists
        let avgExpenditures: utility.IAverageExpenditureByFuel = {
          fiscalYear: this.state.SelectedYear,
          granteeId: this.state.SelectedGranteeId,
          validPMDataReported: true,
          sedsElectricNonHeatExpenditureNaturalGas: null,
          sedsElectricNonHeatCodeNaturalGas: '',
          sedsElectricNonHeatExpenditureFuelOil: null,
          sedsElectricNonHeatCodeFuelOil: '',
          sedsElectricNonHeatExpenditurePropane: null,
          sedsElectricNonHeatCodePropane: '',
          computedAverageExpenditureNaturalGas: null,
          computedAverageExpenditureFuelOil: null,
          computedAverageExpenditurePropane: null,
          numberOfAssistedHouseholdsElectric: null,
          numberOfAssistedHouseholdsNaturalGas: null,
          numberOfAssistedHouseholdsFuelOil: null,
          numberOfAssistedHouseholdsPropane: null,
          householdsBillingDataElectric: null,
          householdsBillingDataNaturalGas: null,
          householdsBillingDataFuelOil: null,
          householdsBillingDataPropane: null,
        };
        if (this.state.selectedAssessmentTypeToCreate == "1"
          || this.state.selectedAssessmentTypeToCreate == "2b"
          || this.state.selectedAssessmentTypeToCreate == "5"
          || this.state.selectedAssessmentTypeToCreate == "oa") {
          //get seds data, averageExpenses and num households served
          const utilityWorker: utility.Worker = new utility.Worker();
          //msr
          try {
            avgExpenditures = await utilityWorker.getSedsData(this.state.SelectedGranteeId, this.state.SelectedYear);
          }
          catch (err) {
            console.log(err);
            this.state.showError(err.message);
            return;
          }


          //if no valid pm data reported for a previous year, display an error
          if (avgExpenditures.validPMDataReported === false) {
            const errormessage: string = `Your state did not file a complete Performance Measures Report for ${this.state.SelectedYear}.
                                                      Therefore, it is not possible to assess the quality of your data for that year.`;
            this.setState({
              ErrorMessage: '',
              CreateAssessmentErrorMessage: errormessage,
              ShowSpinner: false,
            });
            return;
          }
          else {
            this.setState({
              ErrorMessage: '',
              CreateAssessmentErrorMessage: '',
            });
          }

        }
        //save new assessment in database
        const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
        let assesmentId: number = 0;
        try {
          assesmentId = await assessmentWorker.addAssessment(
            this.state.SelectedGranteeId
            , this.state.SelectedYear
            , this.state.selectedAssessmentTypeToCreate);
        }
        catch (err) {
          console.log(err);
          this.state.showError(err.message);
          return;
        }
        switch (this.state.selectedAssessmentTypeToCreate) {
          case "1": {

            //update number of households assisted for each fuel
            let newFuelTypes: Assessment1FuelTypesStatusHolder = new Assessment1FuelTypesStatusHolder();
            //newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment1FuelTypesStatus);
            newFuelTypes.FiscalYear = this.state.SelectedYear;
            newFuelTypes.Grantee = this.state.SelectedGranteeId;
            newFuelTypes.NaturalGas.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas;
            newFuelTypes.NaturalGas.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodeNaturalGas;
            newFuelTypes.FuelOil.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditureFuelOil;
            newFuelTypes.FuelOil.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodeFuelOil;
            newFuelTypes.Propane.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditurePropane;
            newFuelTypes.Propane.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodePropane;
            newFuelTypes.NaturalGas.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureNaturalGas;
            newFuelTypes.FuelOil.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureFuelOil;
            newFuelTypes.Propane.computedAverageExpenditure = avgExpenditures.computedAverageExpenditurePropane;
            newFuelTypes.NaturalGas.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsPropane;

            //add this data to columns that are to be updated
            //using associative array so that we don't have to code to determine whether to add or update
            let newFieldsToUpdate: utility.IFieldToUpdate[] = [];
            if (avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodeNaturalGas != '') {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodeNaturalGas
              });
            }
            if (avgExpenditures.sedsElectricNonHeatExpenditureFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditureFuelOil
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodeFuelOil != '') {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodeFuelOil
              });
            }
            if (avgExpenditures.sedsElectricNonHeatExpenditurePropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditurePropane
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodePropane != '') {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodePropane
              });
            }
            if (avgExpenditures.computedAverageExpenditureNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditureNaturalGas
              });
            }
            if (avgExpenditures.computedAverageExpenditureFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditureFuelOil
              });
            }
            if (avgExpenditures.computedAverageExpenditurePropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditurePropane
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsNaturalGas
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsFuelOil
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsPropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsPropane
              });
            }

            //update saved assessment details
            if (newFieldsToUpdate.length > 0) {
              try {
                const result = await assessmentWorker.updateAssessmentDetails(assesmentId
                  , "1"
                  , newFieldsToUpdate
                );
              }
              catch (err) {
                console.log(err);
                this.state.showError(err.message);
                return;
              }
            }



            pageToGoTo = AppPagesEnum.Assessment1;
            headerText = "Assessment 1: Defining Data Requirements";
            let showNextStepDisabled = this.state.assessment1ShowNextStepDisabled(newFuelTypes, Assessment1StepsEnum.EnterDataAverageExpenditures);

            this.setState({
              FieldsToUpdate: [],
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment1StepsEnum.EnterDataAverageExpenditures,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment1FuelTypesStatus: newFuelTypes,
              Assessment1ShowNextStepDisabled: showNextStepDisabled,
              SelectedGranteeName: this.state.getGranteeName(newFuelTypes.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "2a": {
            pageToGoTo = AppPagesEnum.Assessment2a;
            headerText = "Assessment 2A: Data Collection - Vendors";
            let newModel: Assessment2aModel = new Assessment2aModel();
            //newModel = Object.assign(newModel, this.state.Assessment2aModelInstance);
            newModel.FiscalYear = this.state.SelectedYear;
            newModel.Grantee = this.state.SelectedGranteeId;
            let showNextStepDisabled = this.state.assessment2aShowNextStepDisabled(newModel, Assessment1StepsEnum.EnterDataAverageExpenditures);
            this.setState({
              ErrorMessage: '',
              Assessment2aShowNextStepDisabled: showNextStepDisabled,
              CurrentAssessementStepIndex: Assessment2aStepsEnum.EnterNumVendors,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment2aModelInstance: newModel,
              SelectedGranteeName: this.state.getGranteeName(newModel.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "2b": {
            //update number of households assisted for each fuel
            let newFuelTypes: Assessment2bFuelTypesStatusHolder = new Assessment2bFuelTypesStatusHolder();
            //newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment2bFuelTypesStatus);
            newFuelTypes.FiscalYear = this.state.SelectedYear;
            newFuelTypes.Grantee = this.state.SelectedGranteeId;
            newFuelTypes.Electric.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsElectric;
            newFuelTypes.NaturalGas.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsPropane;

            //add this data to columns that are to be updated
            //using associative array so that we don't have to code to determine whether to add or update
            let newFieldsToUpdate: utility.IFieldToUpdate[] = [];
            if (avgExpenditures.numberOfAssistedHouseholdsElectric !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Electric'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsElectric
              });
            }

            if (avgExpenditures.numberOfAssistedHouseholdsNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsNaturalGas
              });
            }

            if (avgExpenditures.numberOfAssistedHouseholdsPropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsFuelOil
              });
            }

            if (avgExpenditures.numberOfAssistedHouseholdsPropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsPropane
              });
            }
            if (newFieldsToUpdate.length > 0) {
              //update saved assessment details
              try {
                const result = await assessmentWorker.updateAssessmentDetails(assesmentId
                  , "2b"
                  , newFieldsToUpdate
                );
              }
              catch (err) {
                console.log(err);
                this.state.showError(err.message);
                return;
              }
            }

            let showNextStepDisabled: boolean = this.state.assessment2bShowNextStepDisabled(newFuelTypes, Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived)

            pageToGoTo = AppPagesEnum.Assessment2b;
            headerText = "Assessment 2B: Data Collection – Households";

            this.setState({
              FieldsToUpdate: [],
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment2bStepsEnum.EnterDataNumHouseholdsDataReceived,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment2bFuelTypesStatus: newFuelTypes,
              Assessment2bShowNextStepDisabled: showNextStepDisabled,
              SelectedGranteeName: this.state.getGranteeName(newFuelTypes.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "3a": {
            let showNextStepDisabled = this.state.Assessment3aShowNextStepDisabled;
            //update number of households assisted for each fuel
            let newFuelTypes: Assessment3aFuelTypesStatusHolder = new Assessment3aFuelTypesStatusHolder();
            //newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3aFuelTypesStatus);
            newFuelTypes.FiscalYear = this.state.SelectedYear;
            newFuelTypes.Grantee = this.state.SelectedGranteeId;

            let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
              fiscalYear: this.state.SelectedYear,
              granteeId: this.state.SelectedGranteeId,
              numberOfAssistedHouseholdsAll: null,
              numberOfAssistedHouseholdsElectric: null,
              numberOfAssistedHouseholdsNaturalGas: null,
              numberOfAssistedHouseholdsFuelOil: null,
              numberOfAssistedHouseholdsPropane: null,
              numberOfAssistedHouseholdsOther: null,
              householdsBillingDataElectric: null,
              householdsBillingDataFuelOil: null,
              householdsBillingDataNaturalGas: null,
              householdsBillingDataPropane: null,
            };

            //get number of households assisted
            const utilityWorker: utility.Worker = new utility.Worker();
            try {
              numHouseholdsAssisted = await utilityWorker.getNumhouseHolds(this.state.SelectedGranteeId, this.state.SelectedYear);
            }
            catch (err) {
              console.log(err);
              this.state.showError(err.message);
              return;
            }

            if (numHouseholdsAssisted.numberOfAssistedHouseholdsElectric != null) {
              newFuelTypes.Electric.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsElectric;
              newFuelTypes.NaturalGas.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas;
              newFuelTypes.FuelOil.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil;
              newFuelTypes.Propane.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsPropane;
              showNextStepDisabled = false;
            }

            //add this data to columns that are to be updated
            //using associative array so that we don't have to code to determine whether to add or update
            let newFieldsToUpdate: utility.IFieldToUpdate[] = [];
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsElectric !== null) {
              let newFieldElectric: utility.IFieldToUpdate = {
                'fuel': 'Electric'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsElectric
              };
              newFieldsToUpdate.push(newFieldElectric);
            }
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas !== null) {
              let newFieldNaturalGas: utility.IFieldToUpdate = {
                'fuel': 'NaturalGas'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas
              };
              newFieldsToUpdate.push(newFieldNaturalGas);
            }
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil !== null) {
              let newFieldFuelOil: utility.IFieldToUpdate = {
                'fuel': 'FuelOil'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil
              };
              newFieldsToUpdate.push(newFieldFuelOil);
            }
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsPropane !== null) {
              let newFieldPropane: utility.IFieldToUpdate = {
                'fuel': 'Propane'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsPropane
              };
              newFieldsToUpdate.push(newFieldPropane);
            }
            if (newFieldsToUpdate.length > 0) {
              //update saved assessment details
              try {
                const result = await assessmentWorker.updateAssessmentDetails(assesmentId
                  , "3a"
                  , newFieldsToUpdate
                );
              }
              catch (err) {
                console.log(err);
                this.state.showError(err.message);
                return;
              }
            }

            pageToGoTo = AppPagesEnum.Assessment3a;
            headerText = "Assessment 3A: Data Recording &  Processing – Vendor Assignment";

            this.setState({
              FieldsToUpdate: [],
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment3aStepsEnum.EnterDataNumHouseholds,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              HouseholdsAssisted: numHouseholdsAssisted,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment3aFuelTypesStatus: newFuelTypes,
              Assessment3aShowNextStepDisabled: showNextStepDisabled,
              SelectedGranteeName: this.state.getGranteeName(newFuelTypes.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "3b": {

            //update number of households assisted for each fuel
            let newFuelTypes: Assessment3bFuelTypesStatusHolder = new Assessment3bFuelTypesStatusHolder();
            //newFuelTypes = Object.assign(newFuelTypes, this.state.Assessment3bFuelTypesStatus);
            newFuelTypes.FiscalYear = this.state.SelectedYear;
            newFuelTypes.Grantee = this.state.SelectedGranteeId;

            let numHouseholdsAssisted: utility.INumHouseholdsByFuel = {
              fiscalYear: this.state.SelectedYear,
              granteeId: this.state.SelectedGranteeId,
              numberOfAssistedHouseholdsAll: null,
              numberOfAssistedHouseholdsElectric: null,
              numberOfAssistedHouseholdsNaturalGas: null,
              numberOfAssistedHouseholdsFuelOil: null,
              numberOfAssistedHouseholdsPropane: null,
              numberOfAssistedHouseholdsOther: null,
              householdsBillingDataElectric: null,
              householdsBillingDataNaturalGas: null,
              householdsBillingDataFuelOil: null,
              householdsBillingDataPropane: null,
            };

            //get number of households assisted
            const utilityWorker: utility.Worker = new utility.Worker();

            try {
              numHouseholdsAssisted = await utilityWorker.getNumhouseHolds(this.state.SelectedGranteeId, this.state.SelectedYear);
            }
            catch (err) {
              console.log(err);
              this.state.showError(err.message);
              return;
            }

            newFuelTypes.NaturalGas.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.totalAssistedhHNum = numHouseholdsAssisted.numberOfAssistedHouseholdsPropane;
            newFuelTypes.NaturalGas.hHElecticAndMainHeatDataNum = numHouseholdsAssisted.householdsBillingDataNaturalGas;
            newFuelTypes.FuelOil.hHElecticAndMainHeatDataNum = numHouseholdsAssisted.householdsBillingDataFuelOil;
            newFuelTypes.Propane.hHElecticAndMainHeatDataNum = numHouseholdsAssisted.householdsBillingDataPropane;

            //add this data to columns that are to be updated
            //using associative array so that we don't have to code to determine whether to add or update
            let newFieldsToUpdate: utility.IFieldToUpdate[] = [];
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas !== null) {
              let newFieldNaturalGas: utility.IFieldToUpdate = {
                'fuel': 'NaturalGas'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsNaturalGas
              };
              newFieldsToUpdate.push(newFieldNaturalGas);
            }
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil !== null) {
              let newFieldFuelOil: utility.IFieldToUpdate = {
                'fuel': 'FuelOil'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsFuelOil
              };
              newFieldsToUpdate.push(newFieldFuelOil);
            }
            if (numHouseholdsAssisted.numberOfAssistedHouseholdsPropane !== null) {
              let newFieldPropane: utility.IFieldToUpdate = {
                'fuel': 'Propane'
                , 'field': 'totalAssistedhHNum'
                , 'value': numHouseholdsAssisted.numberOfAssistedHouseholdsPropane
              };
              newFieldsToUpdate.push(newFieldPropane);
            }
            if (numHouseholdsAssisted.householdsBillingDataNaturalGas !== null) {
              let newFieldBillingDataNaturalGas: utility.IFieldToUpdate = {
                'fuel': 'NaturalGas'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': numHouseholdsAssisted.householdsBillingDataNaturalGas
              };
              newFieldsToUpdate.push(newFieldBillingDataNaturalGas);
            }
            if (numHouseholdsAssisted.householdsBillingDataFuelOil !== null) {
              let newFieldBillingDataFuelOil: utility.IFieldToUpdate = {
                'fuel': 'FuelOil'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': numHouseholdsAssisted.householdsBillingDataFuelOil
              };
              newFieldsToUpdate.push(newFieldBillingDataFuelOil);
            }
            if (numHouseholdsAssisted.householdsBillingDataPropane !== null) {
              let newFieldBillingDataPropane: utility.IFieldToUpdate = {
                'fuel': 'Propane'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': numHouseholdsAssisted.householdsBillingDataPropane
              };
              newFieldsToUpdate.push(newFieldBillingDataPropane);
            }
            if (newFieldsToUpdate.length > 0) {
              //update saved assessment details
              try {
                const result = await assessmentWorker.updateAssessmentDetails(assesmentId
                  , "3b"
                  , newFieldsToUpdate
                );
              }
              catch (err) {
                console.log(err);
                this.state.showError(err.message);
                return;
              }
            }


            let showNextStepDisabled = this.state.assessment3bShowNextStepDisabled(newFuelTypes, Assessment3bStepsEnum.EnterDataNumHouseholds)

            pageToGoTo = AppPagesEnum.Assessment3b;
            headerText = "Assessment 3B: Data Recording & Processing – Account Matching";

            this.setState({
              FieldsToUpdate: [],
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment3bStepsEnum.EnterDataNumHouseholds,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              HouseholdsAssisted: numHouseholdsAssisted,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              Assessment3bFuelTypesStatus: newFuelTypes,
              Assessment3bShowNextStepDisabled: showNextStepDisabled,
              SelectedGranteeName: this.state.getGranteeName(newFuelTypes.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "4": {

            this.setState({
              ErrorMessage: '',
              CurrentAssessementStepIndex: Assessment4StepsEnum.Q1TrackAcctNoFormat,
              ShowSpinner: false,
              CurrentAppPage: AppPagesEnum.Assessment4,
              MainHeader: "Assessment 4: Data Checking Routines:",
              CurrentEditingAssessmentKey: assesmentId,
              Assessment4ModelInstance: new Assessment4Model(),
              Assessment4ShowNextStepDisabled: false,
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
          case "oa": {
            let showNextStepDisabled = this.state.OverallAssessmentShowNextStepDisabled;
            //update number of households assisted for each fuel
            let newFuelTypes: OverallAssessmentFuelTypesStatusHolder = new OverallAssessmentFuelTypesStatusHolder();
            //newFuelTypes = Object.assign(newFuelTypes, this.state.OverallAssessmentFuelTypesStatus);
            newFuelTypes.FiscalYear = this.state.SelectedYear;
            newFuelTypes.Grantee = this.state.SelectedGranteeId;

            newFuelTypes.NaturalGas.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas;
            newFuelTypes.NaturalGas.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodeNaturalGas;
            newFuelTypes.FuelOil.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditureFuelOil;
            newFuelTypes.FuelOil.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodeFuelOil;
            newFuelTypes.Propane.sedsElectricNonHeatExpenditure = avgExpenditures.sedsElectricNonHeatExpenditurePropane;
            newFuelTypes.Propane.sedsElectricNonHeatCode = avgExpenditures.sedsElectricNonHeatCodePropane;
            newFuelTypes.NaturalGas.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureNaturalGas;
            newFuelTypes.FuelOil.computedAverageExpenditure = avgExpenditures.computedAverageExpenditureFuelOil;
            newFuelTypes.Propane.computedAverageExpenditure = avgExpenditures.computedAverageExpenditurePropane;

            newFuelTypes.Electric.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsElectric;
            newFuelTypes.NaturalGas.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsNaturalGas;
            newFuelTypes.FuelOil.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsFuelOil;
            newFuelTypes.Propane.totalAssistedhHNum = avgExpenditures.numberOfAssistedHouseholdsPropane;

            newFuelTypes.Electric.hHElecticAndMainHeatDataNum = avgExpenditures.householdsBillingDataElectric;
            newFuelTypes.NaturalGas.hHElecticAndMainHeatDataNum = avgExpenditures.householdsBillingDataNaturalGas;
            newFuelTypes.FuelOil.hHElecticAndMainHeatDataNum = avgExpenditures.householdsBillingDataFuelOil;
            newFuelTypes.Propane.hHElecticAndMainHeatDataNum = avgExpenditures.householdsBillingDataPropane;

            //add this data to columns that are to be updated
            //using associative array so that we don't have to code to determine whether to add or update
            let newFieldsToUpdate: utility.IFieldToUpdate[] = [];
            if (avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditureNaturalGas
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodeNaturalGas != '') {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodeNaturalGas
              });
            }
            if (avgExpenditures.sedsElectricNonHeatExpenditureFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditureFuelOil
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodeFuelOil != '') {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodeFuelOil
              });
            }
            if (avgExpenditures.sedsElectricNonHeatExpenditurePropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'sedsElectricNonHeatExpenditure'
                , 'value': avgExpenditures.sedsElectricNonHeatExpenditurePropane
              });
            }
            if (avgExpenditures.sedsElectricNonHeatCodePropane != '') {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'sedsElectricNonHeatCode'
                , 'value': avgExpenditures.sedsElectricNonHeatCodePropane
              });
            }


            if (avgExpenditures.computedAverageExpenditureNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditureNaturalGas
              });
            }
            if (avgExpenditures.computedAverageExpenditureFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditureFuelOil
              });
            }
            if (avgExpenditures.computedAverageExpenditurePropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'computedAverageExpenditure'
                , 'value': avgExpenditures.computedAverageExpenditurePropane
              });
            }

            if (avgExpenditures.numberOfAssistedHouseholdsElectric !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Electric'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsElectric
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsNaturalGas
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsFuelOil
              });
            }
            if (avgExpenditures.numberOfAssistedHouseholdsPropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'totalAssistedhHNum'
                , 'value': avgExpenditures.numberOfAssistedHouseholdsPropane
              });
            }
            if (avgExpenditures.householdsBillingDataElectric !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Electric'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': avgExpenditures.householdsBillingDataElectric
              });
            }
            if (avgExpenditures.householdsBillingDataNaturalGas !== null) {
              newFieldsToUpdate.push({
                'fuel': 'NaturalGas'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': avgExpenditures.householdsBillingDataNaturalGas
              });
            }
            if (avgExpenditures.householdsBillingDataFuelOil !== null) {
              newFieldsToUpdate.push({
                'fuel': 'FuelOil'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': avgExpenditures.householdsBillingDataFuelOil
              });
            }
            if (avgExpenditures.householdsBillingDataPropane !== null) {
              newFieldsToUpdate.push({
                'fuel': 'Propane'
                , 'field': 'hHElecticAndMainHeatDataNum'
                , 'value': avgExpenditures.householdsBillingDataPropane
              });
            }

            //update saved assessment details
            if (newFieldsToUpdate.length > 0) {
              try {
                const result = await assessmentWorker.updateAssessmentDetails(assesmentId
                  , "oa"
                  , newFieldsToUpdate
                );
              }
              catch (err) {
                console.log(err);
                this.state.showError(err.message);
                return;
              }
            }

            if (newFuelTypes.NaturalGas.computedAverageExpenditure === null
              || newFuelTypes.FuelOil.computedAverageExpenditure === null
              || newFuelTypes.Propane.computedAverageExpenditure === null) {
              showNextStepDisabled = true;
            }
            else {
              showNextStepDisabled = false;
            }
            pageToGoTo = AppPagesEnum.OverallAssessment;
            headerText = "Overall Reliability Assessment";

            this.setState({
              FieldsToUpdate: [],
              ErrorMessage: '',
              CurrentAssessementStepIndex: OverallAssessmentStepsEnum.Assessment1EnterData,
              ShowSpinner: false,
              CurrentAppPage: pageToGoTo,
              MainHeader: headerText,
              CurrentEditingAssessmentKey: assesmentId,
              OverallAssessmentFuelTypesStatus: newFuelTypes,
              OverallAssessmentShowNextStepDisabled: showNextStepDisabled,
              SelectedGranteeName: this.state.getGranteeName(newFuelTypes.Grantee),
            });
            document.getElementById("app").scrollIntoView()
            return;
          }
        }
      }
    }.bind(inParentComponent),
    SelectStateAndYearFieldChangeHandler: function (inEvent: any): void {
      //If we're updating grantee, then get grantee name and set that too
      let granteeName = this.state.SelectedGranteeName;//SelectedGranteeName
      if (inEvent.target.id == "SelectedGranteeId") {
        const granteeArray = this.state.Grantees.filter(e => { return e.granteeId == inEvent.target.value; });
        if (granteeArray.length == 0) {
        }
        else {
          granteeName = granteeArray[0].granteeName;
        }

      }
      this.setState({
        ErrorMessage: '',
        [inEvent.target.id]: inEvent.target.value,
        SelectedGranteeName: granteeName,
        // Clear the editing assessment key so changing year/state forces a
        // fresh assessment load instead of reusing the stale one.
        CurrentEditingAssessmentKey: null,
      });
    }.bind(inParentComponent),
    //--------------------------------------------------------------------------------

    /*--------------------------------------------------------------------------------
     * Start page methods
     *--------------------------------------------------------------------------------*/
    startPageAddAssessment: function (): void {

      this.setState({
        ErrorMessage: '',
        MainHeader: 'Start a New Assessment',
        CurrentAppPage: AppPagesEnum.StartNewAssessment,
      });

      document.getElementById("app").scrollIntoView()
    }.bind(inParentComponent),
    startStartNewAssessementPageBack: function (): void {
      this.setState({
        ErrorMessage: '',
        MainHeader: 'Overview',
        CurrentAppPage: AppPagesEnum.StartPage,
      });
    }.bind(inParentComponent),
    startNewAssessementAssessmentSelected: async function (inSelectedAssessment: number): Promise<void> {
      this.state.showSpinner();

      //get grantees
      const baseWorker: worker.baseWorker = new worker.baseWorker();
      let grantees: worker.IGrantee[] = [];
      try {
        grantees = await baseWorker.getGrantees();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      const utilityWorker: utility.Worker = new utility.Worker();
      let sedsValueCodesAssociativeArray = [];
      try {
        sedsValueCodesAssociativeArray = await utilityWorker.getSedsCodeValues();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //get SEDS years (TODO: check this.  Assume SEDS years are OK - may only apply to assessment 1)
      let fiscalYears: worker.IFiscalYear[] = [];
      try {
        fiscalYears = await baseWorker.getSedsYears();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      //set current user grantee
      var newUserInfo: worker.IUserInfo = {
        granteeId: this.state.UserInfo.granteeId,
        viewAll: this.state.UserInfo.viewAll,
        loggedIn: this.state.UserInfo.loggedIn
      };
      if (this.state.UserInfo != null && this.state.UserInfo.granteeId != -1 && grantees.length > 0) {
        //get grantee name for current user
        var userGrantee = grantees.filter((element) => element.granteeId === this.state.UserInfo.granteeId);
        if (userGrantee.length > 0) {
          newUserInfo.granteeName = userGrantee[0].granteeName;
        }
      }

      //const assessment1Holder: Assessment1FuelTypesStatusHolder = new Assessment1FuelTypesStatusHolder();
      //const assessment2Holder: Assessment2FuelTypesStatusHolder = new Assessment2FuelTypesStatusHolder();
      //const assessment3Holder: Assessment3FuelTypesStatusHolder = new Assessment3FuelTypesStatusHolder();
      //const assessment4Model: Assessment4Model = new Assessment4Model();
      //const assessment5Holder: Assessment5FuelTypesStatusHolder = new Assessment5FuelTypesStatusHolder();

      this.setState({
        ErrorMessage: '',
        //Assessment1FuelTypesStatus: assessment1Holder,
        //Assessment2FuelTypesStatus: assessment2Holder,
        //Assessment3FuelTypesStatus: assessment3Holder,
        //Assessment4Model: assessment4Model,
        //Assessment5FuelTypesStatus: assessment5Holder,
        ShowSpinner: false,
        UserInfo: newUserInfo,
        Grantees: grantees,
        FiscalYears: fiscalYears,
        selectedAssessmentTypeToCreate: inSelectedAssessment,
        MainHeader: 'Select State and Year',
        CurrentAppPage: AppPagesEnum.SelectStateAndYear,
        SedsValueCodesAssociativeArray: sedsValueCodesAssociativeArray,
      });
    }.bind(inParentComponent),
    deleteSavedAssessment: async function (inAssessmentId: number, inAssessmentId2: string): Promise<void> {
      // Delete from server.
      this.state.showSpinner();
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      try {
        await assessmentWorker.deleteSavedAssessment(inAssessmentId, inAssessmentId2);
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }
      // Remove from list by creating a copy that does not include the current contact.
      const al = this.state.savedAssessments.filter((inElement) => inElement.assessmentId != inAssessmentId);
      // Update state.
      this.setState({
        ErrorMessage: '',
        savedAssessments: al,
        ShowSpinner: false
      });
    }.bind(inParentComponent), /* End deleteContact(). */
    backToStart: async function (): Promise<void> {
      const assessmentWorker: assessmentInfo.Worker = new assessmentInfo.Worker();
      
      let newSavedAssessments: assessmentInfo.ISavedAssessmentInfo[] = null;
      try {
        newSavedAssessments = await assessmentWorker.listSavedAssessments();
      }
      catch (err) {
        console.log(err);
        this.state.showError(err.message);
        return;
      }

      let newFieldsToUpdate = [];
      let newCurrentAssessementStepIndex = null;
      let newAssessment1FuelTypesStatus = new Assessment1FuelTypesStatusHolder();
      let newAssessment2aModelInstance = new Assessment2aModel();

      this.setState({
        MainHeader: 'Overview',
        CurrentAppPage: AppPagesEnum.StartPage,
        ErrorMessage: '',
        ShowSpinner: false,
        savedAssessments: newSavedAssessments,
        selectedAssessmentTypeToCreate: null,
        CurrentEditingAssessmentKey: null,
        FieldsToUpdate: newFieldsToUpdate,
        CurrentAssessementStepIndex: newCurrentAssessementStepIndex,
        Assessment1FuelTypesStatus: newAssessment1FuelTypesStatus,
        Assessment1ShowNextStepDisabled: true,
        Assessment2aModelInstance: newAssessment2aModelInstance,
        Assessment2aShowNextStepDisabled: true,
      });
    }.bind(inParentComponent),

    //----------------------------------------------------------------------------------------------


    //----------------------------------------------------------------------------------------------
    //Helper methods
    //----------------------------------------------------------------------------------------------
    getGridRowBoundaryClass: function (viewAll: boolean, fuelName: string): string {
      let className: string = "";
      if (viewAll === false) {
        className = " rowboundary3_4 ";
      }
      else {
        switch (fuelName) {
          case "NaturalGas":
            className = " rowboundary3_4 ";
            break;
          case "FuelOil":
            className = " rowboundary4_5 ";
            break;
          case "Propane":
            className = " rowboundary5_6 ";
            break;
        }
      }
      return className;
    },
    getGridRowClass: function (viewAll: boolean, fuelName: string): string {
      let className: string = "";
      if (viewAll === false) {
        className = " row2 ";
      }
      else {
        switch (fuelName) {
          case "Electric":
            className = " row2 ";
            break;
          case "NaturalGas":
            className = " row3 ";
            break;
          case "FuelOil":
            className = " row4 ";
            break;
          case "Propane":
            className = " row5 ";
            break;
        }
      }
      return className;
    },
    stringToNullOrBoolean: function (inString: string): boolean {
      if (inString === "true") {
        return true;
      }
      else if (inString === "false") {
        return false;
      }
      else {
        return null;
      }
    },
    getGranteeName: function (inGranteeId: number): string {
      let granteeName: string = "";
      const granteeArray = this.state.Grantees.filter(e => { return Number(e.granteeId) === Number(inGranteeId); });
      if (granteeArray.length > 0) {
        granteeName = granteeArray[0].granteeName;
      }
      return granteeName;
    }.bind(inParentComponent),
    setCurrentUserInfo: function (inUser: worker.IUserInfo): void {
      this.setState({
        ErrorMessage: '',
        UserInfo: inUser
        , SelectedGranteeId: inUser.granteeId
      });
    }.bind(inParentComponent),
    addAssessmentsToList: function (inAssessments: assessmentInfo.ISavedAssessmentInfo[]): void {
      ////copy all the elements from baseComponent.state.savedAssessments to a new array
      //const copyOfSavedAssessments: assessmentInfo.ISavedAssessmentInfo[] = this.state.savedAssessments.slice(0);
      ////push the new assessment into our copy array
      //copyOfSavedAssessments.push(inAssessment);

      this.setState({
        ErrorMessage: ''
        , savedAssessments: inAssessments
      });

    }.bind(inParentComponent),
    showError: function (errorMessage: string) {
      this.setState({
        ShowSpinner: false,
        ErrorMessage: errorMessage,
      });
      this.state.scrollToTop();
    }.bind(inParentComponent),
    showSpinner: function () {
      this.setState({
        ErrorMessage: '',
        ShowSpinner: true,
      });
    }.bind(inParentComponent),
    hideSpinner: function () {
      this.setState({
        ShowSpinner: false,
      });
    }.bind(inParentComponent),
    nullOrNumberToNumber: function (inNumber: any): any {

      let origString = String(inNumber);
      if (String(inNumber).endsWith(".")) {
        inNumber += '0';
      }
      let notANumber: boolean = isNaN(Number(inNumber));

      //if it's a number
      if (notANumber === false) {
        if (origString == '') {
          return origString;
        }
        else {
          return Number(inNumber);
        }
      }
      else {
        return 0;
      }
    },
    isNullOrEmpty: function (inString: any): boolean {
      if (inString === '' || inString === null) {
        return true;
      }
      else {
        return false;
      }
    },
    scrollToTop: function () {
      const yOffset = -100;
      const element = document.getElementById("app");
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    },

    showActionPlan: function (inObject: any): boolean {
      for (const [key, value] of Object.entries(inObject)) {
        if (key.endsWith("Desc") && value !== '' && value !== null) {
          return true;
        }
      }
      return false;
    }.bind(inParentComponent)


    //----------------------------------------------------------------------------------------------
  };
} /* End createState(). */

